/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
	/** Custom scalar for amount rate with precision */
	AmountPercentage: any;
	/** An arbitrary precision signed decimal */
	BigDecimal: string;
	/** An RFC-3339 compliant Full Date Scalar */
	Date: any;
	/** A slightly refined version of RFC-3339 compliant DateTime Scalar */
	DateTime: any;
	/** Custom scalar for destination tag */
	DestinationTag: any;
	/** Custom scalar for precision float */
	PrecisionFloat: { value: string; precision: number };
	/** Custom scalar for price unit value */
	PriceUnitValue: any;
	/** Custom scalar for unit value */
	UnitValue: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
	/** Custom scalar for value change */
	ValueChange: { value: string; percentage: number };
	_FieldSet: any;
}

export interface AddPriceAlertInput {
	amount: Scalars["BigDecimal"];
	assetId: Scalars["ID"];
	comparison: PriceAlertComparison;
	fiatId: Scalars["ID"];
}

/**
 * Input for adding or removing assets from the watchlist.
 *
 * ! Use AddToWatchlistInput and RemoveFromWatchlistInput instead.
 */
export interface AddRemoveWatchlistInput {
	ids?: InputMaybe<Array<Scalars["ID"]>>;
	pids?: InputMaybe<Array<Scalars["String"]>>;
}

/** Input for adding assets from the watchlist. */
export interface AddToWatchlistInput {
	ids?: InputMaybe<Array<Scalars["ID"]>>;
	pids?: InputMaybe<Array<Scalars["String"]>>;
}

/** Payload after adding assets to the watchlist. */
export interface AddToWatchlistPayload {
	__typename?: "AddToWatchlistPayload";
	addedEdges?: Maybe<Array<Maybe<WatchlistEdge>>>;
}

export interface Address {
	__typename?: "Address";
	city?: Maybe<Scalars["String"]>;
	country: Country;
	street?: Maybe<Scalars["String"]>;
	zipcode?: Maybe<Scalars["String"]>;
}

export interface AffiliatePayoutTransaction extends Node, Transaction {
	__typename?: "AffiliatePayoutTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface AirdropTransaction extends Node, Transaction {
	__typename?: "AirdropTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Interface for all asset types. */
export interface Asset {
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Interface for all asset types. */
export interface AssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Interface for all asset types. */
export interface AssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Interface for all asset types. */
export interface AssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface AssetCategory extends FacetValue {
	__typename?: "AssetCategory";
	count?: Maybe<Scalars["Int"]>;
	key: Scalars["String"];
	name: Scalars["String"];
}

export interface AssetCategoryFacet extends Facet {
	__typename?: "AssetCategoryFacet";
	field?: Maybe<Scalars["String"]>;
	values?: Maybe<Array<Maybe<AssetCategory>>>;
}

/** Facet option for filtering assets by category. */
export interface AssetCategoryFacetOption extends FacetOption {
	__typename?: "AssetCategoryFacetOption";
	key: FacetOptionKey;
	values: Array<AssetCategoryFacetOptionValue>;
}

/** Value for an asset category facet option. */
export interface AssetCategoryFacetOptionValue extends FacetOptionValue {
	__typename?: "AssetCategoryFacetOptionValue";
	count?: Maybe<Scalars["Int"]>;
	displayName: Scalars["String"];
	value: Scalars["String"];
}

/** A paginated connection of assets. */
export interface AssetConnection {
	__typename?: "AssetConnection";
	edges?: Maybe<Array<Maybe<AssetEdge>>>;
	facet?: Maybe<Array<AssetCategoryFacet>>;
	facetOptions?: Maybe<Array<FacetOption>>;
	facets?: Maybe<Array<Facet>>;
	pageInfo?: Maybe<PageInfo>;
	totalCount?: Maybe<Scalars["Int"]>;
}

export interface AssetDepositTransaction extends Node, Transaction {
	__typename?: "AssetDepositTransaction";
	actions?: Maybe<Array<TransactionAction>>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	destinationTag?: Maybe<Scalars["DestinationTag"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	hash?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	/**  Additional fields */
	network?: Maybe<Network>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
	vasp?: Maybe<Scalars["String"]>;
	walletAddress?: Maybe<Scalars["String"]>;
	walletHost?: Maybe<Scalars["String"]>;
}

/** Represents a document related to an asset. */
export interface AssetDocument {
	__typename?: "AssetDocument";
	type: AssetDocumentType;
	url: Scalars["String"];
}

/** The type of an asset document. */
export enum AssetDocumentType {
	Legal = "LEGAL"
}

/** An edge in the asset connection. */
export interface AssetEdge {
	__typename?: "AssetEdge";
	cursor?: Maybe<Scalars["String"]>;
	node?: Maybe<Asset>;
}

export interface AssetFacetValue extends FacetValue {
	__typename?: "AssetFacetValue";
	count?: Maybe<Scalars["Int"]>;
	key?: Maybe<Scalars["String"]>;
	value?: Maybe<Asset>;
}

/** Input for filtering assets. */
export interface AssetFilter {
	categoryIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	excludeTypes?: InputMaybe<Array<InputMaybe<AssetType>>>;
	inPortfolio?: InputMaybe<Scalars["Boolean"]>;
	inWatchlist?: InputMaybe<Scalars["Boolean"]>;
	isSpotlight?: InputMaybe<Scalars["Boolean"]>;
	marginLongFilter?: InputMaybe<AssetMarginFilter>;
	marginShortFilter?: InputMaybe<AssetMarginFilter>;
	orderTypes?: InputMaybe<Array<InputMaybe<AssetOrderType>>>;
	settings?: InputMaybe<AssetSettings>;
	status?: InputMaybe<AssetStatus>;
	statuses?: InputMaybe<Array<InputMaybe<AssetStatus>>>;
	type?: InputMaybe<AssetType>;
	types?: InputMaybe<Array<AssetType>>;
}

/** Represents the available asset filter options. */
export enum AssetFilterOption {
	All = "ALL",
	Commodity = "COMMODITY",
	Crypto = "CRYPTO",
	EquityRight = "EQUITY_RIGHT",
	Etf = "ETF",
	Index = "INDEX",
	Leverage = "LEVERAGE",
	Metal = "METAL",
	SecurityToken = "SECURITY_TOKEN",
	Staking = "STAKING",
	Stock = "STOCK"
}

/** Facet option for filtering assets based on specific filter options. */
export interface AssetFilterOptionFacetOption extends FacetOption {
	__typename?: "AssetFilterOptionFacetOption";
	key: FacetOptionKey;
	values: Array<AssetFilterOptionFacetOptionValue>;
}

/** Value for an asset filter option facet. */
export interface AssetFilterOptionFacetOptionValue extends FacetOptionValue {
	__typename?: "AssetFilterOptionFacetOptionValue";
	analyticsName: Scalars["String"];
	count?: Maybe<Scalars["Int"]>;
	displayName: Scalars["String"];
	filterOption: AssetFilterOption;
	value: Scalars["String"];
}

export interface AssetFinancials {
	__typename?: "AssetFinancials";
	ebitda?: Maybe<Array<AssetFinancialsMetricPoint>>;
	netIncome?: Maybe<Array<AssetFinancialsMetricPoint>>;
	revenue?: Maybe<Array<AssetFinancialsMetricPoint>>;
}

export interface AssetFinancialsMetricPoint {
	__typename?: "AssetFinancialsMetricPoint";
	change: Scalars["UnitValue"];
	changePercentage: Scalars["PrecisionFloat"];
	periodYear: Scalars["Int"];
	value: Scalars["UnitValue"];
}

/** Represents a group of assets within a portfolio. */
export interface AssetGroup extends Node {
	__typename?: "AssetGroup";
	id: Scalars["ID"];
	name?: Maybe<Scalars["String"]>;
}

/** Input for filtering an asset. */
export interface AssetInput {
	id?: InputMaybe<Scalars["ID"]>;
	idInternal?: InputMaybe<Scalars["Int"]>;
	pid?: InputMaybe<Scalars["String"]>;
}

/**
 * Used for Stock, Etf, and Commodity assets to indicate the duration of the last trading day.
 * Needed for displaying ohlc intraday charts correctly.
 */
export interface AssetLastTradingDay {
	__typename?: "AssetLastTradingDay";
	endTime: Scalars["DateTime"];
	startTime: Scalars["DateTime"];
}

/** Input for filtering margin assets. */
export interface AssetMarginFilter {
	buyActive?: InputMaybe<Scalars["Boolean"]>;
	maximumLeverage?: InputMaybe<Scalars["String"]>;
	sellActive?: InputMaybe<Scalars["Boolean"]>;
}

/** Represents margin settings for an asset. */
export interface AssetMarginSettings {
	__typename?: "AssetMarginSettings";
	automatedOrderEnabled?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	maximumLeverage?: Maybe<Scalars["Int"]>;
	sellActive?: Maybe<Scalars["Boolean"]>;
}

export enum AssetMarketGroup {
	Crypto = "CRYPTO",
	Stocks = "STOCKS"
}

export interface AssetMarketGroupFacetOption extends FacetOption {
	__typename?: "AssetMarketGroupFacetOption";
	key: FacetOptionKey;
	values: Array<AssetMarketGroupFacetOptionValue>;
}

export interface AssetMarketGroupFacetOptionValue extends FacetOptionValue {
	__typename?: "AssetMarketGroupFacetOptionValue";
	count?: Maybe<Scalars["Int"]>;
	displayName: Scalars["String"];
	filterOption: AssetMarketGroup;
	value: Scalars["String"];
}

/** The available order types for assets. */
export enum AssetOrderType {
	Limit = "LIMIT",
	MarginLong = "MARGIN_LONG",
	MarginShort = "MARGIN_SHORT",
	Market = "MARKET",
	Staking = "STAKING"
}

/** A paginated connection of portfolios for a specific asset. */
export interface AssetPortfoliosConnection {
	__typename?: "AssetPortfoliosConnection";
	assetBalance?: Maybe<Scalars["PrecisionFloat"]>;
	edges?: Maybe<Array<Maybe<AssetPortfoliosEdge>>>;
	fiatBalance?: Maybe<Scalars["PrecisionFloat"]>;
	totalInvested?: Maybe<Scalars["PrecisionFloat"]>;
	totalReturn?: Maybe<Scalars["ValueChange"]>;
}

/** An edge in the asset portfolios connection, containing a portfolio node. */
export interface AssetPortfoliosEdge {
	__typename?: "AssetPortfoliosEdge";
	cursor: Scalars["String"];
	node?: Maybe<Portfolio>;
}

/** Input for requesting asset price updates. */
export interface AssetPriceUpdateInput {
	ids?: InputMaybe<Array<Scalars["ID"]>>;
	pids?: InputMaybe<Array<Scalars["String"]>>;
}

/** Holds settings for asset filtering. */
export interface AssetSettings {
	buyActive?: InputMaybe<Scalars["Boolean"]>;
	includeHiddenFromDiscovery?: InputMaybe<Scalars["Boolean"]>;
	includeHiddenFromMovers?: InputMaybe<Scalars["Boolean"]>;
	includeIndexOnly?: InputMaybe<Scalars["Boolean"]>;
	sellActive?: InputMaybe<Scalars["Boolean"]>;
}

/** The available sort options for assets. */
export enum AssetSort {
	EstimatedRewards = "ESTIMATED_REWARDS",
	MarketCap = "MARKET_CAP",
	Name = "NAME",
	PriceChangeDay = "PRICE_CHANGE_DAY",
	PriceChangeFiveYears = "PRICE_CHANGE_FIVE_YEARS",
	PriceChangeMonth = "PRICE_CHANGE_MONTH",
	PriceChangeSixMonths = "PRICE_CHANGE_SIX_MONTHS",
	PriceChangeWeek = "PRICE_CHANGE_WEEK",
	PriceChangeYear = "PRICE_CHANGE_YEAR",
	Volatility_30D = "VOLATILITY_30D",
	Volume_30D = "VOLUME_30D"
}

/** The status of an asset. */
export enum AssetStatus {
	New = "NEW",
	Staking = "STAKING",
	Trending = "TRENDING"
}

/** Facet option for filtering assets by tag. */
export interface AssetTagFacetOption extends FacetOption {
	__typename?: "AssetTagFacetOption";
	displayName: Scalars["String"];
	key: FacetOptionKey;
	values: Array<AssetTagFacetOptionValue>;
}

/** Value for an asset tag facet option. */
export interface AssetTagFacetOptionValue extends FacetOptionValue {
	__typename?: "AssetTagFacetOptionValue";
	count?: Maybe<Scalars["Int"]>;
	displayName: Scalars["String"];
	value: Scalars["String"];
}

/** Represents a tag for an asset. */
export interface AssetTagType {
	__typename?: "AssetTagType";
	key: Scalars["String"];
	values: Array<Scalars["String"]>;
}

/** The type of an asset. */
export enum AssetType {
	All = "ALL",
	Commodity = "COMMODITY",
	Crypto = "CRYPTO",
	EquityComplexEtf = "EQUITY_COMPLEX_ETF",
	EquityEtc = "EQUITY_ETC",
	EquityEtf = "EQUITY_ETF",
	EquityRight = "EQUITY_RIGHT",
	EquityStock = "EQUITY_STOCK",
	Etf = "ETF",
	Index = "INDEX",
	Leverage = "LEVERAGE",
	Metal = "METAL",
	SecurityToken = "SECURITY_TOKEN",
	Stock = "STOCK"
}

/** A wallet holding a crypto or asset, with additional fiat balance field. */
export interface AssetWallet extends Node, Wallet {
	__typename?: "AssetWallet";
	asset: Asset;
	availableBalance?: Maybe<Scalars["UnitValue"]>;
	/**  Additional fields */
	fiatBalance?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	/**
	 * Indicates if this wallet is the default wallet for its asset
	 * based on the wallet owner - shared-default is the default wallet for the user
	 */
	isDefault?: Maybe<Scalars["Boolean"]>;
	name: Scalars["String"];
	pid: Scalars["String"];
	reservedBalance?: Maybe<Scalars["UnitValue"]>;
	totalBalance?: Maybe<Scalars["UnitValue"]>;
	transactions?: Maybe<TransactionsConnection>;
}

/** A wallet holding a crypto or asset, with additional fiat balance field. */
export interface AssetWalletTransactionsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	input?: InputMaybe<TransactionsListInput>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** An edge in the asset wallets connection. */
export interface AssetWalletEdge {
	__typename?: "AssetWalletEdge";
	cursor: Scalars["String"];
	node?: Maybe<Wallet>;
}

/** A paginated connection of asset wallets. */
export interface AssetWalletsConnection {
	__typename?: "AssetWalletsConnection";
	assetBalance?: Maybe<Scalars["UnitValue"]>;
	averageBuyPrice?: Maybe<Scalars["PrecisionFloat"]>;
	fiatBalance?: Maybe<Scalars["UnitValue"]>;
	totalInvested?: Maybe<Scalars["UnitValue"]>;
	totalReturn?: Maybe<Scalars["ValueChange"]>;
	totalReturn24h?: Maybe<Scalars["ValueChange"]>;
	wallets?: Maybe<Array<Maybe<AssetWallet>>>;
}

export interface AssetWithdrawalTransaction extends Node, Transaction {
	__typename?: "AssetWithdrawalTransaction";
	actions?: Maybe<Array<TransactionAction>>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	destinationTag?: Maybe<Scalars["DestinationTag"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	hash?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	/**  Additional fields */
	network?: Maybe<Network>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
	vasp?: Maybe<Scalars["String"]>;
	walletAddress?: Maybe<Scalars["String"]>;
	walletHost?: Maybe<Scalars["String"]>;
}

/** Input for requesting a list of assets. */
export interface AssetsListInput {
	facets?: InputMaybe<Array<FacetOptionInput>>;
	filters?: InputMaybe<AssetFilter>;
	ids?: InputMaybe<Array<Scalars["ID"]>>;
	pids?: InputMaybe<Array<Scalars["String"]>>;
	query?: InputMaybe<Scalars["String"]>;
	sortBy?: InputMaybe<AssetSort>;
	sortOrder?: InputMaybe<SortOrder>;
}

export interface BankTransferPaymentOption extends PaymentOptionDetails {
	__typename?: "BankTransferPaymentOption";
	/**  additional field */
	bankName?: Maybe<Scalars["String"]>;
	bic?: Maybe<Scalars["String"]>;
	iban?: Maybe<Scalars["String"]>;
	logo?: Maybe<Array<Image>>;
	name: Scalars["String"];
}

export interface BestRewardTransaction extends Node, Transaction {
	__typename?: "BestRewardTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface BitpandaPayDebitTransaction extends Node, Transaction {
	__typename?: "BitpandaPayDebitTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<PaymentOptionDetails>;
	type: TransactionType;
}

/** Union of all broker asset types. */
export type BrokerAsset =
	| CommodityAsset
	| CryptoAsset
	| EquityComplexEtfAsset
	| EquityEtcAsset
	| EquityEtfAsset
	| EquityRightAsset
	| EquityStockAsset
	| EtfAsset
	| Fiat
	| GenericAsset
	| IndexAsset
	| LeverageAsset
	| MetalAsset
	| SecurityTokenAsset
	| StockAsset;

/** Value for a broker asset facet option. */
export interface BrokerAssetFacetOptionValue extends FacetOptionValue {
	__typename?: "BrokerAssetFacetOptionValue";
	asset?: Maybe<BrokerAsset>;
	count?: Maybe<Scalars["Int"]>;
	value: Scalars["String"];
}

export interface BrokerAssetFacetValue extends FacetValue {
	__typename?: "BrokerAssetFacetValue";
	count?: Maybe<Scalars["Int"]>;
	key?: Maybe<Scalars["String"]>;
	value?: Maybe<BrokerAsset>;
}

export interface BuyTransaction extends Node, Transaction {
	__typename?: "BuyTransaction";
	actions?: Maybe<Array<TransactionAction>>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	closingPosition?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	leverage?: Maybe<Scalars["PrecisionFloat"]>;
	leverageDirection?: Maybe<LeverageDirection>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	price?: Maybe<Scalars["PriceUnitValue"]>;
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	startingPosition?: Maybe<Scalars["UnitValue"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	totalLeverage?: Maybe<Scalars["PrecisionFloat"]>;
	type: TransactionType;
	vsnPrice?: Maybe<Scalars["PriceUnitValue"]>;
	vsnUsed?: Maybe<Scalars["UnitValue"]>;
}

export interface CardCashbackTransaction extends Node, Transaction {
	__typename?: "CardCashbackTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface CardCreditTransaction extends Node, Transaction {
	__typename?: "CardCreditTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

export interface CardFeeTransaction extends Node, Transaction {
	__typename?: "CardFeeTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
}

export interface CardPaymentOption extends PaymentOptionDetails {
	__typename?: "CardPaymentOption";
	/**  additional field */
	cardNumber?: Maybe<Scalars["String"]>;
	logo?: Maybe<Array<Image>>;
	name: Scalars["String"];
}

export interface CardPaymentTransaction extends Node, Transaction {
	__typename?: "CardPaymentTransaction";
	address?: Maybe<Scalars["String"]>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	/**  Additional fields */
	merchant?: Maybe<Scalars["String"]>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

export interface CashPlusAddedTransaction extends Node, Transaction {
	__typename?: "CashPlusAddedTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
}

/** Payout frequency for Cash Plus rewards. */
export enum CashPlusPayoutFrequency {
	Monthly = "MONTHLY"
}

export interface CashPlusRemovedTransaction extends Node, Transaction {
	__typename?: "CashPlusRemovedTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface CashPlusRewardTransaction extends Node, Transaction {
	__typename?: "CashPlusRewardTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Cash Plus rewards summary for the portfolio. */
export interface CashPlusRewards {
	__typename?: "CashPlusRewards";
	availableFiats: Array<Maybe<Fiat>>;
	isActive: Scalars["Boolean"];
	totalRewards: Scalars["UnitValue"];
}

/** Status of Cash Plus feature for a fiat wallet. */
export enum CashPlusStatus {
	Available = "AVAILABLE",
	Enrolled = "ENROLLED",
	NotAvailable = "NOT_AVAILABLE"
}

export interface ChargebackTransaction extends Node, Transaction {
	__typename?: "ChargebackTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

/** Represents a commodity asset. */
export interface CommodityAsset extends Asset, Node {
	__typename?: "CommodityAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	fundSize?: Maybe<Scalars["UnitValue"]>;
	fundSizeYear?: Maybe<Scalars["Int"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	lastTradingDay?: Maybe<AssetLastTradingDay>;
	lastUpdated?: Maybe<Scalars["DateTime"]>;
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	metrics?: Maybe<EtpAssetMetrics>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	/**  Additional fields */
	priceHighDay?: Maybe<Scalars["UnitValue"]>;
	priceHighYear?: Maybe<Scalars["UnitValue"]>;
	priceLowDay?: Maybe<Scalars["UnitValue"]>;
	priceLowYear?: Maybe<Scalars["UnitValue"]>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volatilityPercentage30d?: Maybe<Scalars["PrecisionFloat"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Represents a commodity asset. */
export interface CommodityAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a commodity asset. */
export interface CommodityAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a commodity asset. */
export interface CommodityAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents a contact. */
export interface Contact extends Node {
	__typename?: "Contact";
	fields?: Maybe<Array<ContactField>>;
	id: Scalars["ID"];
	transactions?: Maybe<TransactionsConnection>;
}

/** Represents a contact. */
export interface ContactTransactionsArgs {
	input?: InputMaybe<TransactionsListInput>;
}

/** An edge in the contacts connection. */
export interface ContactEdge {
	__typename?: "ContactEdge";
	cursor: Scalars["String"];
	node?: Maybe<Contact>;
}

/** Represents a field within a contact, such as an address or email. */
export interface ContactField {
	__typename?: "ContactField";
	destinationTag?: Maybe<Scalars["String"]>;
	isExternal: Scalars["Boolean"];
	name?: Maybe<Scalars["String"]>;
	network?: Maybe<Network>;
	type: ContactFieldType;
	value: Scalars["String"];
}

/** Represents the type of a contact field (e.g., email, crypto address). */
export enum ContactFieldType {
	AaveAddress = "AAVE_ADDRESS",
	AdaAddress = "ADA_ADDRESS",
	AergoAddress = "AERGO_ADDRESS",
	AgixAddress = "AGIX_ADDRESS",
	AlgoAddress = "ALGO_ADDRESS",
	AnkrAddress = "ANKR_ADDRESS",
	AntAddress = "ANT_ADDRESS",
	ApeAddress = "APE_ADDRESS",
	Api3Address = "API3_ADDRESS",
	AtomAddress = "ATOM_ADDRESS",
	AudioAddress = "AUDIO_ADDRESS",
	AvaxAddress = "AVAX_ADDRESS",
	AxlAddress = "AXL_ADDRESS",
	AxsAddress = "AXS_ADDRESS",
	AzeroAddress = "AZERO_ADDRESS",
	BandAddress = "BAND_ADDRESS",
	BatAddress = "BAT_ADDRESS",
	BchAddress = "BCH_ADDRESS",
	BcutAddress = "BCUT_ADDRESS",
	BestAddress = "BEST_ADDRESS",
	BicoAddress = "BICO_ADDRESS",
	BigtimeAddress = "BIGTIME_ADDRESS",
	BnbAddress = "BNB_ADDRESS",
	BntAddress = "BNT_ADDRESS",
	BtcAddress = "BTC_ADDRESS",
	CagaAddress = "CAGA_ADDRESS",
	CelrAddress = "CELR_ADDRESS",
	ChapzAddress = "CHAPZ_ADDRESS",
	ChrAddress = "CHR_ADDRESS",
	ChzAddress = "CHZ_ADDRESS",
	CompAddress = "COMP_ADDRESS",
	CotiAddress = "COTI_ADDRESS",
	CrvAddress = "CRV_ADDRESS",
	DashAddress = "DASH_ADDRESS",
	DcbAddress = "DCB_ADDRESS",
	DogeAddress = "DOGE_ADDRESS",
	DotAddress = "DOT_ADDRESS",
	DydxAddress = "DYDX_ADDRESS",
	Email = "EMAIL",
	EnjAddress = "ENJ_ADDRESS",
	EnsAddress = "ENS_ADDRESS",
	EosAddress = "EOS_ADDRESS",
	EthAddress = "ETH_ADDRESS",
	EurocAddress = "EUROC_ADDRESS",
	F3Address = "F3_ADDRESS",
	FetAddress = "FET_ADDRESS",
	FlokiAddress = "FLOKI_ADDRESS",
	FlrAddress = "FLR_ADDRESS",
	FluxAddress = "FLUX_ADDRESS",
	FtmAddress = "FTM_ADDRESS",
	FttAddress = "FTT_ADDRESS",
	GalaAddress = "GALA_ADDRESS",
	GalAddress = "GAL_ADDRESS",
	GlmAddress = "GLM_ADDRESS",
	GrtAddress = "GRT_ADDRESS",
	GtaiAddress = "GTAI_ADDRESS",
	GtAddress = "GT_ADDRESS",
	HotAddress = "HOT_ADDRESS",
	IdAddress = "ID_ADDRESS",
	ImxAddress = "IMX_ADDRESS",
	InfraAddress = "INFRA_ADDRESS",
	InjAddress = "INJ_ADDRESS",
	IostAddress = "IOST_ADDRESS",
	IotxAddress = "IOTX_ADDRESS",
	KmdAddress = "KMD_ADDRESS",
	KncAddress = "KNC_ADDRESS",
	LdoAddress = "LDO_ADDRESS",
	LinkAddress = "LINK_ADDRESS",
	LrcAddress = "LRC_ADDRESS",
	LskAddress = "LSK_ADDRESS",
	LtcAddress = "LTC_ADDRESS",
	ManaAddress = "MANA_ADDRESS",
	MaskAddress = "MASK_ADDRESS",
	MaticAddress = "MATIC_ADDRESS",
	MaviaAddress = "MAVIA_ADDRESS",
	MiotaAddress = "MIOTA_ADDRESS",
	MkrAddress = "MKR_ADDRESS",
	NeoAddress = "NEO_ADDRESS",
	OceanAddress = "OCEAN_ADDRESS",
	OmgAddress = "OMG_ADDRESS",
	OndoAddress = "ONDO_ADDRESS",
	OneinchAddress = "ONEINCH_ADDRESS",
	OntAddress = "ONT_ADDRESS",
	OpAddress = "OP_ADDRESS",
	PanAddress = "PAN_ADDRESS",
	QntAddress = "QNT_ADDRESS",
	RayAddress = "RAY_ADDRESS",
	RenAddress = "REN_ADDRESS",
	RepAddress = "REP_ADDRESS",
	RndrAddress = "RNDR_ADDRESS",
	RplAddress = "RPL_ADDRESS",
	RsrAddress = "RSR_ADDRESS",
	SandAddress = "SAND_ADDRESS",
	ShibAddress = "SHIB_ADDRESS",
	SklAddress = "SKL_ADDRESS",
	SlnAddress = "SLN_ADDRESS",
	SmrAddress = "SMR_ADDRESS",
	SnxAddress = "SNX_ADDRESS",
	SolAddress = "SOL_ADDRESS",
	SrmAddress = "SRM_ADDRESS",
	StmxAddress = "STMX_ADDRESS",
	StorjAddress = "STORJ_ADDRESS",
	StrkAddress = "STRK_ADDRESS",
	SushiAddress = "SUSHI_ADDRESS",
	TomoAddress = "TOMO_ADDRESS",
	TrxAddress = "TRX_ADDRESS",
	UmaAddress = "UMA_ADDRESS",
	UniAddress = "UNI_ADDRESS",
	UsdcAddress = "USDC_ADDRESS",
	UsdtAddress = "USDT_ADDRESS",
	VanryAddress = "VANRY_ADDRESS",
	VetAddress = "VET_ADDRESS",
	ViaAddress = "VIA_ADDRESS",
	VraAddress = "VRA_ADDRESS",
	WavesAddress = "WAVES_ADDRESS",
	WsiAddress = "WSI_ADDRESS",
	XdbAddress = "XDB_ADDRESS",
	XemAddress = "XEM_ADDRESS",
	XlmAddress = "XLM_ADDRESS",
	XrpAddress = "XRP_ADDRESS",
	XtzAddress = "XTZ_ADDRESS",
	YfiAddress = "YFI_ADDRESS",
	ZecAddress = "ZEC_ADDRESS",
	ZrxAddress = "ZRX_ADDRESS"
}

/** Input for identifying a contact. */
export interface ContactInput {
	id: Scalars["ID"];
}

/** A paginated connection of contacts. */
export interface ContactsConnection {
	__typename?: "ContactsConnection";
	edges?: Maybe<Array<Maybe<ContactEdge>>>;
	pageInfo?: Maybe<PageInfo>;
}

export interface Country extends Node {
	__typename?: "Country";
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility. Use id instead. */
	idInternal: Scalars["Int"];
	iso2?: Maybe<Scalars["String"]>;
	name?: Maybe<Scalars["String"]>;
}

/** Represents a crypto asset. */
export interface CryptoAsset extends Asset, Node {
	__typename?: "CryptoAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	indexOnly?: Maybe<Scalars["Boolean"]>;
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	marginLongSettings?: Maybe<AssetMarginSettings>;
	marginShortSettings?: Maybe<AssetMarginSettings>;
	/**  Additional fields */
	marketCap?: Maybe<Scalars["PrecisionFloat"]>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceHighDay?: Maybe<Scalars["UnitValue"]>;
	priceHighYear?: Maybe<Scalars["UnitValue"]>;
	priceLowDay?: Maybe<Scalars["UnitValue"]>;
	priceLowYear?: Maybe<Scalars["UnitValue"]>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	staking?: Maybe<Staking>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volatilityPercentage30d?: Maybe<Scalars["PrecisionFloat"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Represents a crypto asset. */
export interface CryptoAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a crypto asset. */
export interface CryptoAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a crypto asset. */
export interface CryptoAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface CryptoMergerTransaction extends Node, Transaction {
	__typename?: "CryptoMergerTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	price?: Maybe<Scalars["PriceUnitValue"]>;
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** The type of currency. */
export enum CurrencyType {
	Asset = "ASSET",
	Fiat = "FIAT",
	Measurable = "MEASURABLE",
	Shares = "SHARES",
	Unit = "UNIT"
}

export interface DefaultPaymentOption extends PaymentOptionDetails {
	__typename?: "DefaultPaymentOption";
	logo?: Maybe<Array<Image>>;
	name: Scalars["String"];
}

export interface DelistingTransaction extends Node, Transaction {
	__typename?: "DelistingTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	price?: Maybe<Scalars["PriceUnitValue"]>;
	receivedAmount?: Maybe<Scalars["UnitValue"]>;
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	taxWithheld?: Maybe<Scalars["UnitValue"]>;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/**  Enum representing the destination tag type  */
export enum DestinationTagType {
	DestinationTag = "DestinationTag",
	Memo = "Memo",
	Message = "Message"
}

export interface DividendTransaction extends Node, Transaction {
	__typename?: "DividendTransaction";
	amount: Scalars["UnitValue"];
	asset?: Maybe<Asset>;
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	receivedAmount?: Maybe<Scalars["UnitValue"]>;
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	sourceTaxWithheld?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	taxWithheld?: Maybe<Scalars["UnitValue"]>;
	taxableAmount?: Maybe<Scalars["UnitValue"]>;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Information document for equity assets. */
export interface EquityAssetKeyInformationDocument {
	__typename?: "EquityAssetKeyInformationDocument";
	language: Scalars["String"];
	url: Scalars["String"];
}

/** Represents a complex etf asset */
export interface EquityComplexEtfAsset extends Asset, Node {
	__typename?: "EquityComplexEtfAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	/**  Additional fields */
	exchangeId: Scalars["ID"];
	fundSize?: Maybe<Scalars["UnitValue"]>;
	fundSizeYear?: Maybe<Scalars["Int"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	industry?: Maybe<Scalars["String"]>;
	issuer?: Maybe<Scalars["String"]>;
	keyInformationDocuments?: Maybe<Array<EquityAssetKeyInformationDocument>>;
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	metrics?: Maybe<EtpAssetMetrics>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceStats?: Maybe<PriceStats>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
	wkn?: Maybe<Scalars["String"]>;
}

/** Represents a complex etf asset */
export interface EquityComplexEtfAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a complex etf asset */
export interface EquityComplexEtfAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a complex etf asset */
export interface EquityComplexEtfAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents a Real Commodity asset. */
export interface EquityEtcAsset extends Asset, Node {
	__typename?: "EquityEtcAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	/**  Additional fields */
	exchangeId: Scalars["ID"];
	fundSize?: Maybe<Scalars["UnitValue"]>;
	fundSizeYear?: Maybe<Scalars["Int"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	issuer?: Maybe<Scalars["String"]>;
	keyInformationDocuments?: Maybe<Array<EquityAssetKeyInformationDocument>>;
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	metrics?: Maybe<EtpAssetMetrics>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceStats?: Maybe<PriceStats>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
	wkn?: Maybe<Scalars["String"]>;
}

/** Represents a Real Commodity asset. */
export interface EquityEtcAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a Real Commodity asset. */
export interface EquityEtcAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a Real Commodity asset. */
export interface EquityEtcAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents an Real ETF asset. */
export interface EquityEtfAsset extends Asset, Node {
	__typename?: "EquityEtfAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	/**  Additional fields */
	exchangeId: Scalars["ID"];
	fundSize?: Maybe<Scalars["UnitValue"]>;
	fundSizeYear?: Maybe<Scalars["Int"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	industry?: Maybe<Scalars["String"]>;
	issuer?: Maybe<Scalars["String"]>;
	keyInformationDocuments?: Maybe<Array<EquityAssetKeyInformationDocument>>;
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	metrics?: Maybe<EtpAssetMetrics>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceStats?: Maybe<PriceStats>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
	wkn?: Maybe<Scalars["String"]>;
}

/** Represents an Real ETF asset. */
export interface EquityEtfAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents an Real ETF asset. */
export interface EquityEtfAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents an Real ETF asset. */
export interface EquityEtfAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents a Equity Right assets. */
export interface EquityRightAsset extends Asset, Node {
	__typename?: "EquityRightAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	/**  Additional fields */
	exchangeId: Scalars["ID"];
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Represents a Equity Right assets. */
export interface EquityRightAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a Equity Right assets. */
export interface EquityRightAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a Equity Right assets. */
export interface EquityRightAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents a Real stock assets. Not to be confused with StockAsset which represents the digital stock trading product. */
export interface EquityStockAsset extends Asset, Node {
	__typename?: "EquityStockAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	dividendPayoutFrequency?: Maybe<Scalars["String"]>;
	dividendPayoutRatioYearly?: Maybe<Scalars["PrecisionFloat"]>;
	/**  Additional fields */
	exchangeId: Scalars["ID"];
	financials?: Maybe<AssetFinancials>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	industry?: Maybe<Scalars["String"]>;
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	marketCap?: Maybe<Scalars["UnitValue"]>;
	metrics?: Maybe<StockAssetMetrics>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceStats?: Maybe<PriceStats>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
	wkn?: Maybe<Scalars["String"]>;
}

/** Represents a Real stock assets. Not to be confused with StockAsset which represents the digital stock trading product. */
export interface EquityStockAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a Real stock assets. Not to be confused with StockAsset which represents the digital stock trading product. */
export interface EquityStockAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a Real stock assets. Not to be confused with StockAsset which represents the digital stock trading product. */
export interface EquityStockAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

export enum ErrorDetail {
	/**
	 * The deadline expired before the operation could complete.
	 *
	 * For operations that change the state of the system, this error
	 * may be returned even if the operation has completed successfully.
	 * For example, a successful response from a server could have been
	 * delayed long enough for the deadline to expire.
	 *
	 * HTTP Mapping: 504 Gateway Timeout
	 * Error Type: UNAVAILABLE
	 */
	DeadlineExceeded = "DEADLINE_EXCEEDED",
	/**
	 * The server detected that the client is exhibiting a behavior that
	 * might be generating excessive load.
	 *
	 * HTTP Mapping: 420 Enhance Your Calm
	 * Error Type: UNAVAILABLE
	 */
	EnhanceYourCalm = "ENHANCE_YOUR_CALM",
	/**
	 * The requested field is not found in the schema.
	 *
	 * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
	 * query is valid, but is unable to return a result (if, for example, a
	 * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
	 * returned by the server to signify that the requested field is not known to exist.
	 * This may be returned in lieu of failing the entire query.
	 * See also `PERMISSION_DENIED` for cases where the
	 * requested field is invalid only for the given user or class of users.
	 *
	 * HTTP Mapping: 404 Not Found
	 * Error Type: BAD_REQUEST
	 */
	FieldNotFound = "FIELD_NOT_FOUND",
	/**
	 * The client specified an invalid argument.
	 *
	 * Note that this differs from `FAILED_PRECONDITION`.
	 * `INVALID_ARGUMENT` indicates arguments that are problematic
	 * regardless of the state of the system (e.g., a malformed file name).
	 *
	 * HTTP Mapping: 400 Bad Request
	 * Error Type: BAD_REQUEST
	 */
	InvalidArgument = "INVALID_ARGUMENT",
	/**
	 * The provided cursor is not valid.
	 *
	 * The most common usage for this error is when a client is paginating
	 * through a list that uses stateful cursors. In that case, the provided
	 * cursor may be expired.
	 *
	 * HTTP Mapping: 404 Not Found
	 * Error Type: NOT_FOUND
	 */
	InvalidCursor = "INVALID_CURSOR",
	/**
	 * Unable to perform operation because a required resource is missing.
	 *
	 * Example: Client is attempting to refresh a list, but the specified
	 * list is expired. This requires an action by the client to get a new list.
	 *
	 * If the user is simply trying GET a resource that is not found,
	 * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
	 * is to be used particularly when the user is performing an operation
	 * that requires a particular resource to exist.
	 *
	 * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
	 * Error Type: FAILED_PRECONDITION
	 */
	MissingResource = "MISSING_RESOURCE",
	/**
	 * Service Error.
	 *
	 * There is a problem with an upstream service.
	 *
	 * This may be returned if a gateway receives an unknown error from a service
	 * or if a service is unreachable.
	 * If a request times out which waiting on a response from a service,
	 * `DEADLINE_EXCEEDED` may be returned instead.
	 * If a service returns a more specific error Type, the specific error Type may
	 * be returned instead.
	 *
	 * HTTP Mapping: 502 Bad Gateway
	 * Error Type: UNAVAILABLE
	 */
	ServiceError = "SERVICE_ERROR",
	/**
	 * Request failed due to network errors.
	 *
	 * HTTP Mapping: 503 Unavailable
	 * Error Type: UNAVAILABLE
	 */
	TcpFailure = "TCP_FAILURE",
	/**
	 * Request throttled based on server concurrency limits.
	 *
	 * HTTP Mapping: 503 Unavailable
	 * Error Type: UNAVAILABLE
	 */
	ThrottledConcurrency = "THROTTLED_CONCURRENCY",
	/**
	 * Request throttled based on server CPU limits
	 *
	 * HTTP Mapping: 503 Unavailable.
	 * Error Type: UNAVAILABLE
	 */
	ThrottledCpu = "THROTTLED_CPU",
	/**
	 * The server detected that the client is exhibiting a behavior that
	 * might be generating excessive load.
	 *
	 * HTTP Mapping: 429 Too Many Requests
	 * Error Type: UNAVAILABLE
	 */
	TooManyRequests = "TOO_MANY_REQUESTS",
	/**
	 * The operation is not implemented or is not currently supported/enabled.
	 *
	 * HTTP Mapping: 501 Not Implemented
	 * Error Type: BAD_REQUEST
	 */
	Unimplemented = "UNIMPLEMENTED",
	/**
	 * Unknown error.
	 *
	 * This error should only be returned when no other error detail applies.
	 * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
	 *
	 * HTTP Mapping: 500 Internal Server Error
	 */
	Unknown = "UNKNOWN"
}

export enum ErrorType {
	/**
	 * Bad Request.
	 *
	 * There is a problem with the request.
	 * Retrying the same request is not likely to succeed.
	 * An example would be a query or argument that cannot be deserialized.
	 *
	 * HTTP Mapping: 400 Bad Request
	 */
	BadRequest = "BAD_REQUEST",
	/**
	 * The operation was rejected because the system is not in a state
	 * required for the operation's execution.  For example, the directory
	 * to be deleted is non-empty, an rmdir operation is applied to
	 * a non-directory, etc.
	 *
	 * Service implementers can use the following guidelines to decide
	 * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
	 *
	 * - Use `UNAVAILABLE` if the client can retry just the failing call.
	 * - Use `FAILED_PRECONDITION` if the client should not retry until
	 * the system state has been explicitly fixed.  E.g., if an "rmdir"
	 *      fails because the directory is non-empty, `FAILED_PRECONDITION`
	 * should be returned since the client should not retry unless
	 * the files are deleted from the directory.
	 *
	 * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
	 */
	FailedPrecondition = "FAILED_PRECONDITION",
	/**
	 * Internal error.
	 *
	 * An unexpected internal error was encountered. This means that some
	 * invariants expected by the underlying system have been broken.
	 * This error code is reserved for serious errors.
	 *
	 * HTTP Mapping: 500 Internal Server Error
	 */
	Internal = "INTERNAL",
	/**
	 * The requested entity was not found.
	 *
	 * This could apply to a resource that has never existed (e.g. bad resource id),
	 * or a resource that no longer exists (e.g. cache expired.)
	 *
	 * Note to server developers: if a request is denied for an entire class
	 * of users, such as gradual feature rollout or undocumented allowlist,
	 * `NOT_FOUND` may be used. If a request is denied for some users within
	 * a class of users, such as user-based access control, `PERMISSION_DENIED`
	 * must be used.
	 *
	 * HTTP Mapping: 404 Not Found
	 */
	NotFound = "NOT_FOUND",
	/**
	 * The caller does not have permission to execute the specified
	 * operation.
	 *
	 * `PERMISSION_DENIED` must not be used for rejections
	 * caused by exhausting some resource or quota.
	 * `PERMISSION_DENIED` must not be used if the caller
	 * cannot be identified (use `UNAUTHENTICATED`
	 * instead for those errors).
	 *
	 * This error Type does not imply the
	 * request is valid or the requested entity exists or satisfies
	 * other pre-conditions.
	 *
	 * HTTP Mapping: 403 Forbidden
	 */
	PermissionDenied = "PERMISSION_DENIED",
	/**
	 * The request does not have valid authentication credentials.
	 *
	 * This is intended to be returned only for routes that require
	 * authentication.
	 *
	 * HTTP Mapping: 401 Unauthorized
	 */
	Unauthenticated = "UNAUTHENTICATED",
	/**
	 * Currently Unavailable.
	 *
	 * The service is currently unavailable.  This is most likely a
	 * transient condition, which can be corrected by retrying with
	 * a backoff.
	 *
	 * HTTP Mapping: 503 Unavailable
	 */
	Unavailable = "UNAVAILABLE",
	/**
	 * Unknown error.
	 *
	 * For example, this error may be returned when
	 * an error code received from another address space belongs to
	 * an error space that is not known in this address space.  Also
	 * errors raised by APIs that do not return enough error information
	 * may be converted to this error.
	 *
	 * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
	 * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
	 * by an implementation as being equivalent to INTERNAL.
	 *
	 * When possible, a more specific error should be provided.
	 *
	 * HTTP Mapping: 520 Unknown Error
	 */
	Unknown = "UNKNOWN"
}

/** Represents an ETF asset. */
export interface EtfAsset extends Asset, Node {
	__typename?: "EtfAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	/**  Additional fields */
	documents?: Maybe<Array<AssetDocument>>;
	fundSize?: Maybe<Scalars["UnitValue"]>;
	fundSizeYear?: Maybe<Scalars["Int"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	lastTradingDay?: Maybe<AssetLastTradingDay>;
	lastUpdated?: Maybe<Scalars["DateTime"]>;
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	metrics?: Maybe<EtpAssetMetrics>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceHighDay?: Maybe<Scalars["UnitValue"]>;
	priceHighYear?: Maybe<Scalars["UnitValue"]>;
	priceLowDay?: Maybe<Scalars["UnitValue"]>;
	priceLowYear?: Maybe<Scalars["UnitValue"]>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volatilityPercentage30d?: Maybe<Scalars["PrecisionFloat"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Represents an ETF asset. */
export interface EtfAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents an ETF asset. */
export interface EtfAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents an ETF asset. */
export interface EtfAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents metrics for an Exchange Traded Product. */
export interface EtpAssetMetrics {
	__typename?: "EtpAssetMetrics";
	disclaimer?: Maybe<Scalars["String"]>;
	distributionPolicy?: Maybe<Scalars["String"]>;
	isin: Scalars["String"];
	provider: Scalars["String"];
	replicationMethod?: Maybe<Scalars["String"]>;
	totalExpenseRatioYearly?: Maybe<Scalars["PrecisionFloat"]>;
}

export interface Exchange {
	id: Scalars["ID"];
}

export interface ExchangeConnection {
	__typename?: "ExchangeConnection";
	edges?: Maybe<Array<ExchangeEdge>>;
	pageInfo?: Maybe<PageInfo>;
	totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExchangeEdge {
	__typename?: "ExchangeEdge";
	cursor?: Maybe<Scalars["String"]>;
	node?: Maybe<Exchange>;
}

/**  Facets schema */
export interface Facet {
	field?: Maybe<Scalars["String"]>;
	values?: Maybe<Array<Maybe<FacetValue>>>;
}

/** Interface for a facet option, which groups values under a key. */
export interface FacetOption {
	key: FacetOptionKey;
	values: Array<FacetOptionValue>;
}

/** Input for specifying a facet option filter. */
export interface FacetOptionInput {
	key: FacetOptionKey;
	values?: InputMaybe<Array<Scalars["String"]>>;
}

/** Represents the available keys for facet options. */
export enum FacetOptionKey {
	AssetCategory = "ASSET_CATEGORY",
	AssetFilterOption = "ASSET_FILTER_OPTION",
	AssetMarketGroup = "ASSET_MARKET_GROUP",
	AssetTagCategories = "ASSET_TAG_CATEGORIES",
	AssetTagFocus = "ASSET_TAG_FOCUS",
	AssetTagRegions = "ASSET_TAG_REGIONS",
	AssetTagSectors = "ASSET_TAG_SECTORS",
	AssetTagUnderlyingAssets = "ASSET_TAG_UNDERLYING_ASSETS",
	MarginMaximumLeverageLong = "MARGIN_MAXIMUM_LEVERAGE_LONG",
	MarginMaximumLeverageShort = "MARGIN_MAXIMUM_LEVERAGE_SHORT",
	TransactionFilterOptionAsset = "TRANSACTION_FILTER_OPTION_ASSET",
	TransactionFilterOptionType = "TRANSACTION_FILTER_OPTION_TYPE"
}

/** Interface for a value within a facet option. */
export interface FacetOptionValue {
	count?: Maybe<Scalars["Int"]>;
	value: Scalars["String"];
}

export interface FacetValue {
	count?: Maybe<Scalars["Int"]>;
	key?: Maybe<Scalars["String"]>;
}

/** Represents a fiat currency and its properties. */
export interface Fiat extends Node {
	__typename?: "Fiat";
	exchangeRate: Scalars["BigDecimal"];
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	logos: Array<Image>;
	name: Scalars["String"];
	pid: Scalars["String"];
	symbol: Scalars["String"];
	symbolCharacter: Scalars["String"];
}

/** A paginated connection of fiat currencies. */
export interface FiatConnection {
	__typename?: "FiatConnection";
	edges?: Maybe<Array<Maybe<FiatEdge>>>;
	pageInfo?: Maybe<PageInfo>;
}

export interface FiatDepositTransaction extends Node, Transaction {
	__typename?: "FiatDepositTransaction";
	actions?: Maybe<Array<TransactionAction>>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<PaymentOptionDetails>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** An edge in the fiat connection, containing a fiat node. */
export interface FiatEdge {
	__typename?: "FiatEdge";
	cursor?: Maybe<Scalars["String"]>;
	node?: Maybe<Fiat>;
}

/** Input for identifying a fiat currency. */
export interface FiatInput {
	id?: InputMaybe<Scalars["ID"]>;
	pid?: InputMaybe<Scalars["String"]>;
}

/** A wallet holding fiat currency, with additional Cash Plus fields. */
export interface FiatWallet extends Node, Wallet {
	__typename?: "FiatWallet";
	availableBalance?: Maybe<Scalars["UnitValue"]>;
	cashPlusCurrentReturnRate?: Maybe<Scalars["BigDecimal"]>;
	cashPlusFiatBalance?: Maybe<Scalars["UnitValue"]>;
	cashPlusFundBalance?: Maybe<Scalars["UnitValue"]>;
	cashPlusLastPayout?: Maybe<Scalars["UnitValue"]>;
	cashPlusPayoutFrequency?: Maybe<CashPlusPayoutFrequency>;
	/**  Additional fields */
	cashPlusStatus?: Maybe<CashPlusStatus>;
	cashPlusTotalRewards?: Maybe<Scalars["UnitValue"]>;
	fiat: Fiat;
	id: Scalars["ID"];
	name: Scalars["String"];
	pid: Scalars["String"];
	reservedBalance?: Maybe<Scalars["UnitValue"]>;
	totalBalance?: Maybe<Scalars["UnitValue"]>;
	transactions?: Maybe<TransactionsConnection>;
}

/** A wallet holding fiat currency, with additional Cash Plus fields. */
export interface FiatWalletTotalBalanceArgs {
	forceCurrency?: InputMaybe<Scalars["Boolean"]>;
}

/** A wallet holding fiat currency, with additional Cash Plus fields. */
export interface FiatWalletTransactionsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	input?: InputMaybe<TransactionsListInput>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface FiatWithdrawalTransaction extends Node, Transaction {
	__typename?: "FiatWithdrawalTransaction";
	/**  Additional fields */
	accountHolder?: Maybe<Scalars["String"]>;
	actions?: Maybe<Array<TransactionAction>>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<PaymentOptionDetails>;
	type: TransactionType;
}

export interface FundsReleasedTransaction extends Node, Transaction {
	__typename?: "FundsReleasedTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface FundsReservedTransaction extends Node, Transaction {
	__typename?: "FundsReservedTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
}

export enum Gender {
	Female = "FEMALE",
	Male = "MALE",
	NoAnswer = "NO_ANSWER",
	Other = "OTHER"
}

/** Generic asset response */
export interface GenericAsset extends Asset, Node {
	__typename?: "GenericAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Generic asset response */
export interface GenericAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Generic asset response */
export interface GenericAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Generic asset response */
export interface GenericAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface GenericTransaction extends Node, Transaction {
	__typename?: "GenericTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

export interface GiveawayTransaction extends Node, Transaction {
	__typename?: "GiveawayTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Represents a historical value for a specific period. */
export interface HistoricalValue {
	__typename?: "HistoricalValue";
	period?: Maybe<Scalars["String"]>;
	value?: Maybe<Scalars["BigDecimal"]>;
}

export interface IcoTransaction extends Node, Transaction {
	__typename?: "IcoTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	price?: Maybe<Scalars["PriceUnitValue"]>;
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Data structure representing an image with its URL, MIME type, dimensions, and optional theme. */
export interface Image {
	__typename?: "Image";
	height: Scalars["Int"];
	mimeType: Scalars["String"];
	theme?: Maybe<UiTheme>;
	url: Scalars["String"];
	width: Scalars["Int"];
}

export interface IncomingSecurityTransferTransaction extends Node, Transaction {
	__typename?: "IncomingSecurityTransferTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface IncomingTransferTransaction extends Node, Transaction {
	__typename?: "IncomingTransferTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Represents an BIC asset. */
export interface IndexAsset extends Asset, Node {
	__typename?: "IndexAsset";
	assetAllocation?: Maybe<IndexAssetAllocationConnection>;
	assetHoldings?: Maybe<IndexAssetHoldingConnection>;
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	originalFiat: Fiat;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	/**  Additional fields */
	priceHighDay?: Maybe<Scalars["UnitValue"]>;
	priceHighYear?: Maybe<Scalars["UnitValue"]>;
	priceLowDay?: Maybe<Scalars["UnitValue"]>;
	priceLowYear?: Maybe<Scalars["UnitValue"]>;
	provider: Scalars["String"];
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volatilityPercentage30d?: Maybe<Scalars["PrecisionFloat"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Represents an BIC asset. */
export interface IndexAssetAssetAllocationArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents an BIC asset. */
export interface IndexAssetAssetHoldingsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents an BIC asset. */
export interface IndexAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents an BIC asset. */
export interface IndexAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents an BIC asset. */
export interface IndexAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/**
 * Allocation information to the underlying assets of an index asset
 * (allocation is the the theoretical percentage of the index that is made up by the given asset).
 */
export interface IndexAssetAllocationConnection {
	__typename?: "IndexAssetAllocationConnection";
	edges?: Maybe<Array<IndexAssetAllocationEdge>>;
	pageInfo: PageInfo;
	totalCount?: Maybe<Scalars["Int"]>;
}

export interface IndexAssetAllocationEdge {
	__typename?: "IndexAssetAllocationEdge";
	allocationPercentage: Scalars["PrecisionFloat"];
	cursor?: Maybe<Scalars["String"]>;
	node: Asset;
}

/**
 * Information about holdings of each individual asset within this index asset
 * These can diverge significantly from the allocation
 */
export interface IndexAssetHoldingConnection {
	__typename?: "IndexAssetHoldingConnection";
	edges?: Maybe<Array<IndexAssetHoldingEdge>>;
	pageInfo: PageInfo;
	totalCount?: Maybe<Scalars["Int"]>;
}

export interface IndexAssetHoldingEdge {
	__typename?: "IndexAssetHoldingEdge";
	allocationPercentage: Scalars["PrecisionFloat"];
	assetBalance: Scalars["UnitValue"];
	cursor?: Maybe<Scalars["String"]>;
	fiatBalance: Scalars["UnitValue"];
	node: Asset;
}

export interface IndexBuyTransaction extends Node, Transaction {
	__typename?: "IndexBuyTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface IndexClaimTransaction extends Node, Transaction {
	__typename?: "IndexClaimTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface IndexRebalanceTransaction extends Node, Transaction {
	__typename?: "IndexRebalanceTransaction";
	amount: Scalars["UnitValue"];
	assetsAdded?: Maybe<Scalars["Int"]>;
	assetsRebalanced?: Maybe<Scalars["Int"]>;
	assetsRemoved?: Maybe<Scalars["Int"]>;
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

export interface IndexSellTransaction extends Node, Transaction {
	__typename?: "IndexSellTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

export interface InstantTradeBonusTransaction extends Node, Transaction {
	__typename?: "InstantTradeBonusTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface KeyValueFacetValue extends FacetValue {
	__typename?: "KeyValueFacetValue";
	count?: Maybe<Scalars["Int"]>;
	key?: Maybe<Scalars["String"]>;
	value?: Maybe<Scalars["String"]>;
}

/**  Enum representing the legal classification of a transaction  */
export enum LegalClassification {
	Arts = "ARTS",
	Emts = "EMTS",
	Other = "OTHER"
}

/** Represents a leverage asset. */
export interface LeverageAsset extends Asset, Node {
	__typename?: "LeverageAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	baseAsset?: Maybe<Asset>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	currentPosition?: Maybe<Scalars["UnitValue"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	desiredLeverage?: Maybe<Scalars["PrecisionFloat"]>;
	/**  Additional fields */
	documents?: Maybe<Array<AssetDocument>>;
	effectiveLeverage?: Maybe<Scalars["PrecisionFloat"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	lastBasePrice?: Maybe<Scalars["UnitValue"]>;
	leverageDirection: LeverageDirection;
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	overnightFee?: Maybe<Scalars["PrecisionFloat"]>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceHighDay?: Maybe<Scalars["UnitValue"]>;
	priceHighYear?: Maybe<Scalars["UnitValue"]>;
	priceLowDay?: Maybe<Scalars["UnitValue"]>;
	priceLowYear?: Maybe<Scalars["UnitValue"]>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	releverageTime?: Maybe<Scalars["DateTime"]>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volatilityPercentage30d?: Maybe<Scalars["PrecisionFloat"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Represents a leverage asset. */
export interface LeverageAssetLastBasePriceArgs {
	currency?: InputMaybe<Scalars["String"]>;
}

/** Represents a leverage asset. */
export interface LeverageAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a leverage asset. */
export interface LeverageAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a leverage asset. */
export interface LeverageAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Direction of leverage in a margin position. */
export enum LeverageDirection {
	Long = "LONG",
	Short = "SHORT"
}

export interface LeverageLiquidationTransaction extends Node, Transaction {
	__typename?: "LeverageLiquidationTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	closingPosition?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	price?: Maybe<Scalars["PriceUnitValue"]>;
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	startingPosition?: Maybe<Scalars["UnitValue"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Liquidation transaction refers to the liquidation corporate action of the stock. */
export interface LiquidationTransaction extends Node, Transaction {
	__typename?: "LiquidationTransaction";
	amount: Scalars["UnitValue"];
	asset?: Maybe<Asset>;
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	taxWithheld?: Maybe<Scalars["UnitValue"]>;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Input for specifying a margin asset and leverage direction. */
export interface MarginAssetInput {
	asset: AssetInput;
	leverageDirection: LeverageDirection;
}

export interface MarginBorrowFundsTransaction extends Node, Transaction {
	__typename?: "MarginBorrowFundsTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	/**  Additional fields */
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	/**  EUROB wallet */
	legalClassification?: Maybe<LegalClassification>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	/**  Bitpanda */
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface MarginClosePositionTransaction extends Node, Transaction {
	__typename?: "MarginClosePositionTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	/**  OUTGOING_TRANSFER, MARGIN_REPAY_FUNDS, MARGIN_FEE */
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	leverage: Scalars["PrecisionFloat"];
	leverageDirection: LeverageDirection;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

/**
 * When closing/lquidating a margin position there will be a MarginFeeTransaction in the related transactions.
 *
 * This transaction is build based on the `MARGIN_TRADING_LIQUIDATION_LONG` operation type
 *
 * Must be loaded with the ID (not the pid) otherwise the parent Close or Liquidation transaction will be shown.
 */
export interface MarginFeeTransaction extends Node, Transaction {
	__typename?: "MarginFeeTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	closingFeeAmount: Scalars["UnitValue"];
	/** The data for the specific fees is taken from `/api/v1/accounts/transactions/{transaction_id}` */
	closingFeePercentage: Scalars["PrecisionFloat"];
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	/**  Additional fields */
	from?: Maybe<Wallet>;
	fundingFeeAmount: Scalars["UnitValue"];
	fundingFeePercentage: Scalars["PrecisionFloat"];
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	/**
	 * this is currently hardcoded to Zero (0) as it is not retrned and based on
	 * the data of a fee transaction it's not freasable to calculate it.
	 */
	leverage: Scalars["PrecisionFloat"];
	leverageDirection: LeverageDirection;
	liquidationFeeAmount?: Maybe<Scalars["UnitValue"]>;
	liquidationFeePercentage?: Maybe<Scalars["PrecisionFloat"]>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	totalFees: Scalars["UnitValue"];
	type: TransactionType;
}

/** Health indicator levels for margin positions. */
export enum MarginHealthIndicator {
	High = "HIGH",
	Low = "LOW",
	Medium = "MEDIUM"
}

export interface MarginIncreasePositionTransaction extends Node, Transaction {
	__typename?: "MarginIncreasePositionTransaction";
	/**  Additional fields */
	actions?: Maybe<Array<TransactionAction>>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	borrowedFunds: Scalars["UnitValue"];
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	initialInvestment: Scalars["UnitValue"];
	/**  UnitValue of 0 if leverage is 1x */
	leverage: Scalars["PrecisionFloat"];
	leverageDirection: LeverageDirection;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  INCREASE_MARGIN_POSITION */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	/**  BUY, MARGIN_BORROW_FUNDS */
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Represents the margin level details for a position. */
export interface MarginLevel {
	__typename?: "MarginLevel";
	/** /v1/margin/positions/overview - taken from the `pnl`->`margin_and_risk` -> `margin_level` */
	current: Scalars["PrecisionFloat"];
	/**
	 * /v1/margin/positions/overview - taken from the `pnl`->`margin_and_risk` -> `risk_level` just flipped arround
	 * High Risk = LOW health indicator, Medium Risk = MEDIUM health indicator, Low Risk = HIGH health indicator
	 */
	healthIndicator: MarginHealthIndicator;
	/** /v1/margin/positions/overview - taken from the `pnl`->`margin_and_risk` -> `margin_level_lower_boundary` */
	highHealthThreshold: Scalars["PrecisionFloat"];
	/** /v1/margin/positions/overview - taken from the `pnl`->`margin_and_risk` -> `margin_level_lower_boundary` */
	lowHealthThreshold: Scalars["PrecisionFloat"];
	/** /v1/margin/positions/overview - taken from the `pnl`->`margin_and_risk` -> `margin_level_upper_boundary` */
	maximum: Scalars["PrecisionFloat"];
	/** /v1/margin/positions/overview - taken from the `pnl`->`margin_and_risk` -> `margin_level_lower_boundary` */
	minimum: Scalars["PrecisionFloat"];
}

/** Represents a margin limit order. */
export interface MarginLimitOrder extends Node {
	__typename?: "MarginLimitOrder";
	asset: Asset;
	/** v1/margin/orders/{id} - returning the value of `amount_in_base_asset` */
	assetAmount: Scalars["UnitValue"];
	cancellationDate?: Maybe<Scalars["DateTime"]>;
	cancellationReason?: Maybe<Scalars["String"]>;
	/** v1/margin/orders/{id} - returning value of `created_at` */
	createdAt: Scalars["DateTime"];
	/**
	 * v1/margin/orders/{id} - using the value from `destination_asset_id` to get the user's wallet
	 * ??? - is this the users default wallet for that asset?
	 */
	destination?: Maybe<Wallet>;
	destinationTag: Scalars["String"];
	/** v1/margin/orders/{id} - returning the value of `exit_order_type` */
	exitOrderType: MarginLimitOrderExitOrderType;
	fiat: Fiat;
	id: Scalars["ID"];
	pid: Scalars["String"];
	/** v1/margin/orders/{id} - returning the value of `repaying_funds_in_underlying_asset` */
	repayingFundsInUnderlyingAsset: Scalars["UnitValue"];
	/** v1/margin/orders/{id} - taken from the field with the same name `status` */
	status: MarginLimitOrderStatus;
	/** v1/margin/orders/{id} - returning value of `target_price` */
	targetPrice: Scalars["UnitValue"];
	targetPriceChangePercentage: Scalars["PrecisionFloat"];
	/** v1/margin/orders/{id} - returnig the value of `trade_type` */
	tradeType: MarginLimitOrderTradeType;
}

/** Exit order types for margin limit orders. */
export enum MarginLimitOrderExitOrderType {
	StopLoss = "STOP_LOSS",
	TakeProfit = "TAKE_PROFIT"
}

/** Input for identifying a margin limit order. */
export interface MarginLimitOrderInput {
	id?: InputMaybe<Scalars["ID"]>;
	pid?: InputMaybe<Scalars["String"]>;
}

/** Status of a margin limit order. */
export enum MarginLimitOrderStatus {
	Cancelled = "CANCELLED",
	Open = "OPEN"
}

/** Trade types for margin limit orders. */
export enum MarginLimitOrderTradeType {
	Buy = "BUY",
	Sell = "SELL"
}

/**
 * This transaction is used when a users margin position is liquidated for any reason.
 *
 * This transaction is build based on the `MARGIN_TRADING_LIQUIDATION_LONG` operation type
 */
export interface MarginLiquidationTransaction extends Node, Transaction {
	__typename?: "MarginLiquidationTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	/**
	 * This leverage is being calculated based on on the investment and borrowed funds of the position.
	 * If there is no outgoing transfer, which means the user just pays back the borrowed funds and fees
	 * then the leverage is set to Zero (0).
	 */
	leverage: Scalars["PrecisionFloat"];
	leverageDirection: LeverageDirection;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**
	 * There can be up to 3 related transactions:
	 *  - OUTGOING_TRANSFER
	 *  - MARGIN_REPAY_FUNDS
	 *  - MARGIN_FEE
	 */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

/** Facet for margin maximum leverage. */
export interface MarginMaximumLeverageFacet extends Facet {
	__typename?: "MarginMaximumLeverageFacet";
	field?: Maybe<Scalars["String"]>;
	values?: Maybe<Array<MarginMaximumLeverageFacetValue>>;
}

/** Facet option for filtering margin tradable assets by maximum leverage. */
export interface MarginMaximumLeverageFacetOption extends FacetOption {
	__typename?: "MarginMaximumLeverageFacetOption";
	key: FacetOptionKey;
	values: Array<MarginMaximumLeverageFacetOptionValue>;
}

/** Value for a margin maximum leverage facet option. */
export interface MarginMaximumLeverageFacetOptionValue extends FacetOptionValue {
	__typename?: "MarginMaximumLeverageFacetOptionValue";
	count?: Maybe<Scalars["Int"]>;
	leverage: Scalars["Int"];
	value: Scalars["String"];
}

/** Value for margin maximum leverage facet. */
export interface MarginMaximumLeverageFacetValue extends FacetValue {
	__typename?: "MarginMaximumLeverageFacetValue";
	count?: Maybe<Scalars["Int"]>;
	key: Scalars["String"];
	value: Scalars["Int"];
}

export interface MarginOpenPositionTransaction extends Node, Transaction {
	__typename?: "MarginOpenPositionTransaction";
	/**  Additional fields */
	actions?: Maybe<Array<TransactionAction>>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	borrowedFunds: Scalars["UnitValue"];
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	initialInvestment: Scalars["UnitValue"];
	/**  no 1x on open */
	leverage: Scalars["PrecisionFloat"];
	leverageDirection: LeverageDirection;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  INCREASE_MARGIN_POSITION */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	/**  BUY, MARGIN_BORROW_FUNDS */
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/**
 * Represents a margin trading position.
 *
 * Data is fetched from margin trading endpoints:
 * - /v1/margin/positions/overview
 *   Fetching the list/overview of margin positions
 * - /v1/margin/positions/{assetId}/{direction}
 *   Fetching the details of a specific margin position by asset and leverage direction.
 *   Needs the leveraged asset and the direction (LONG/SHORT) to fetch the position details.
 */
export interface MarginPosition extends Node {
	__typename?: "MarginPosition";
	asset: Asset;
	/** /v1/margin/positions/overview - taken from the `amount` */
	assetPosition: Scalars["UnitValue"];
	availableLimitOrderExitOrderTypes?: Maybe<Array<MarginLimitOrderExitOrderType>>;
	averageOpeningPrice?: Maybe<Scalars["UnitValue"]>;
	borrowedFunds?: Maybe<Scalars["UnitValue"]>;
	/**
	 * /v1/margin/positions/overview - taken from the `amount_in_eur` value in the
	 *   response and converted to the users default fiat currency
	 */
	fiatPosition: Scalars["UnitValue"];
	id: Scalars["ID"];
	initialInvestment?: Maybe<Scalars["UnitValue"]>;
	leverage: Scalars["PrecisionFloat"];
	/** /v1/margin/positions/overview - taken from the `type` */
	leverageDirection: LeverageDirection;
	limitOrders?: Maybe<Array<MarginLimitOrder>>;
	/** /v1/margin/positions/overview - taken from the `pnl`->`liquidation_price_in_eur` */
	liquidationPrice: Scalars["UnitValue"];
	/** /v1/margin/positions/overview - taken from the `pnl`->`liquidation_change_percentage` */
	liquidationThresholdPercentage: Scalars["PrecisionFloat"];
	marginLevel: MarginLevel;
	performance: Scalars["UnitValue"];
	/** /v1/margin/positions/overview - taken from the `type` */
	performancePercentage: Scalars["PrecisionFloat"];
}

/** An edge in the margin positions connection. */
export interface MarginPositionEdge {
	__typename?: "MarginPositionEdge";
	cursor?: Maybe<Scalars["String"]>;
	node?: Maybe<MarginPosition>;
}

/** Filter for margin positions based on health indicators. */
export interface MarginPositionFilter {
	healthIndicators?: InputMaybe<Array<MarginHealthIndicator>>;
}

/** Sorting options for margin positions. */
export enum MarginPositionSort {
	MarginLevel = "MARGIN_LEVEL",
	Performance = "PERFORMANCE"
}

/** Input for filtering and sorting margin positions. */
export interface MarginPositionsInput {
	filter?: InputMaybe<MarginPositionFilter>;
	sortBy?: InputMaybe<MarginPositionSort>;
	sortOrder?: InputMaybe<SortOrder>;
}

export interface MarginRepayFundsTransaction extends Node, Transaction {
	__typename?: "MarginRepayFundsTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	/**  Additional fields */
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Bitpanda */
	price?: Maybe<Scalars["PriceUnitValue"]>;
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	/**  EUROB wallet */
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
}

export interface MarketHours {
	__typename?: "MarketHours";
	overrides: Array<ScheduleOverride>;
	weekly: Array<WeeklySchedule>;
}

/** Represents market indicators. */
export interface MarketIndicators {
	__typename?: "MarketIndicators";
	dominance?: Maybe<Scalars["PrecisionFloat"]>;
	fearAndGreedIndex?: Maybe<Scalars["Int"]>;
	marketCap?: Maybe<Scalars["ValueChange"]>;
	volume?: Maybe<Scalars["ValueChange"]>;
}

/** Represents a metal asset. */
export interface MetalAsset extends Asset, Node {
	__typename?: "MetalAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	/**  Additional fields */
	marketCap?: Maybe<Scalars["PrecisionFloat"]>;
	measurementUnit: Scalars["String"];
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceHighDay?: Maybe<Scalars["UnitValue"]>;
	priceHighYear?: Maybe<Scalars["UnitValue"]>;
	priceLowDay?: Maybe<Scalars["UnitValue"]>;
	priceLowYear?: Maybe<Scalars["UnitValue"]>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volatilityPercentage30d?: Maybe<Scalars["PrecisionFloat"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Represents a metal asset. */
export interface MetalAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a metal asset. */
export interface MetalAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a metal asset. */
export interface MetalAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface MetalStorageFeeTransaction extends Node, Transaction {
	__typename?: "MetalStorageFeeTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
}

/** Available mutations for managing watchlist and spotlight/newsletter subscriptions. */
export interface Mutation {
	__typename?: "Mutation";
	addPriceAlert?: Maybe<PriceAlert>;
	addToWatchlist?: Maybe<AddToWatchlistPayload>;
	removeFromWatchlist?: Maybe<RemoveFromWatchlistPayload>;
	removePriceAlert?: Maybe<RemovePriceAlertPayload>;
	reorderWatchlist?: Maybe<ReorderWatchlistPayload>;
	resolvePrompt?: Maybe<ResolvePromptPayload>;
	subscribeSpotlightAsset?: Maybe<SpotlightAsset>;
	subscribeSpotlightNewsletter?: Maybe<Spotlight>;
}

/** Available mutations for managing watchlist and spotlight/newsletter subscriptions. */
export interface MutationAddPriceAlertArgs {
	input: AddPriceAlertInput;
}

/** Available mutations for managing watchlist and spotlight/newsletter subscriptions. */
export interface MutationAddToWatchlistArgs {
	input: AddToWatchlistInput;
}

/** Available mutations for managing watchlist and spotlight/newsletter subscriptions. */
export interface MutationRemoveFromWatchlistArgs {
	input: RemoveFromWatchlistInput;
}

/** Available mutations for managing watchlist and spotlight/newsletter subscriptions. */
export interface MutationRemovePriceAlertArgs {
	input: RemovePriceAlertInput;
}

/** Available mutations for managing watchlist and spotlight/newsletter subscriptions. */
export interface MutationReorderWatchlistArgs {
	input: Array<ReorderWatchlistInput>;
}

/** Available mutations for managing watchlist and spotlight/newsletter subscriptions. */
export interface MutationResolvePromptArgs {
	input: ResolvePromptInput;
}

/** Available mutations for managing watchlist and spotlight/newsletter subscriptions. */
export interface MutationSubscribeSpotlightAssetArgs {
	input: SpotlightAssetSubscriptionInput;
}

/** Available mutations for managing watchlist and spotlight/newsletter subscriptions. */
export interface MutationSubscribeSpotlightNewsletterArgs {
	input: SpotlightNewsletterSubscriptionInput;
}

/** The network is used for AssetDeposit and AssetWithdrawal- Transactions. Also part of the ContactField type. */
export interface Network extends Node {
	__typename?: "Network";
	id: Scalars["ID"];
	logos: Array<Image>;
	name: Scalars["String"];
	pid: Scalars["String"];
}

/** Basic interface for all connections in the schema. */
export interface Node {
	id: Scalars["ID"];
}

/**
 * Represents OHLC data for an asset.
 * loaded from via pricing provider
 */
export interface OhlcData {
	__typename?: "OhlcData";
	close?: Maybe<Scalars["PrecisionFloat"]>;
	high?: Maybe<Scalars["PrecisionFloat"]>;
	low?: Maybe<Scalars["PrecisionFloat"]>;
	open?: Maybe<Scalars["PrecisionFloat"]>;
	time?: Maybe<Scalars["DateTime"]>;
}

/** Input for requesting OHLC data. */
export interface OhlcInput {
	period?: InputMaybe<TimePeriod>;
}

/**  Enum representing the operation type returned by transaction timeline  */
export enum OperationType {
	AdvancedTradingBuy = "ADVANCED_TRADING_BUY",
	AdvancedTradingRelease = "ADVANCED_TRADING_RELEASE",
	AdvancedTradingReserve = "ADVANCED_TRADING_RESERVE",
	AdvancedTradingSell = "ADVANCED_TRADING_SELL",
	AdvancedTradingSwap = "ADVANCED_TRADING_SWAP",
	AffiliateEarning = "AFFILIATE_EARNING",
	Airdrop = "AIRDROP",
	BestReward = "BEST_REWARD",
	Buy = "BUY",
	B_2B_2CBuy = "B_2_B_2_C_BUY",
	B_2B_2CSell = "B_2_B_2_C_SELL",
	CapitalRepayment = "CAPITAL_REPAYMENT",
	CardCashback = "CARD_CASHBACK",
	CardCharge = "CARD_CHARGE",
	CardCredit = "CARD_CREDIT",
	CardFee = "CARD_FEE",
	Chargeback = "CHARGEBACK",
	Delisting = "DELISTING",
	Deposit = "DEPOSIT",
	Dividend = "DIVIDEND",
	DustSwap = "DUST_SWAP",
	EarnOnFiatBuy = "EARN_ON_FIAT_BUY",
	EarnOnFiatReward = "EARN_ON_FIAT_REWARD",
	EarnOnFiatSell = "EARN_ON_FIAT_SELL",
	EarnOnFiatSwap = "EARN_ON_FIAT_SWAP",
	Giveaway = "GIVEAWAY",
	Ico = "ICO",
	IndexBuy = "INDEX_BUY",
	IndexClaim = "INDEX_CLAIM",
	IndexRebalancing = "INDEX_REBALANCING",
	IndexSell = "INDEX_SELL",
	InstantTradeBonus = "INSTANT_TRADE_BONUS",
	LeverageLiquidation = "LEVERAGE_LIQUIDATION",
	MarginTradingCloseLong = "MARGIN_TRADING_CLOSE_LONG",
	MarginTradingLiquidationLong = "MARGIN_TRADING_LIQUIDATION_LONG",
	MarginTradingOpenLong = "MARGIN_TRADING_OPEN_LONG",
	MergerCash = "MERGER_CASH",
	MergerCashStock = "MERGER_CASH_STOCK",
	MergerCrypto = "MERGER_CRYPTO",
	MergerStock = "MERGER_STOCK",
	MetalStorageFee = "METAL_STORAGE_FEE",
	OnetimeReward = "ONETIME_REWARD",
	Reclaim = "RECLAIM",
	Reconcile = "RECONCILE",
	Refund = "REFUND",
	ReturnOfCapital = "RETURN_OF_CAPITAL",
	ReverseStockSplit = "REVERSE_STOCK_SPLIT",
	Reward = "REWARD",
	RightsIssue = "RIGHTS_ISSUE",
	SavingsPlan = "SAVINGS_PLAN",
	SecuritiesDeposit = "SECURITIES_DEPOSIT",
	SecuritiesWithdrawal = "SECURITIES_WITHDRAWAL",
	Sell = "SELL",
	SpinOff = "SPIN_OFF",
	StagedBuy = "STAGED_BUY",
	StagedSell = "STAGED_SELL",
	Stake = "STAKE",
	StockExchangeBuy = "STOCK_EXCHANGE_BUY",
	StockExchangeSell = "STOCK_EXCHANGE_SELL",
	StockSplit = "STOCK_SPLIT",
	Swap = "SWAP",
	Tax = "TAX",
	TaxNetting = "TAX_NETTING",
	Tender = "TENDER",
	TradingPremium = "TRADING_PREMIUM",
	Unstake = "UNSTAKE",
	UserToUser = "USER_TO_USER",
	Voucher = "VOUCHER",
	Withdrawal = "WITHDRAWAL"
}

export interface OutgoingSecurityTransferTransaction extends Node, Transaction {
	__typename?: "OutgoingSecurityTransferTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

export interface OutgoingTransferTransaction extends Node, Transaction {
	__typename?: "OutgoingTransferTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
}

/** PageInfo is used to provide information about pagination in a connection. */
export interface PageInfo {
	__typename?: "PageInfo";
	endCursor?: Maybe<Scalars["String"]>;
	hasNextPage: Scalars["Boolean"];
	hasPreviousPage: Scalars["Boolean"];
	startCursor?: Maybe<Scalars["String"]>;
}

export interface PaymentOptionDetails {
	logo?: Maybe<Array<Image>>;
	name: Scalars["String"];
}

export interface PhoneNumber {
	__typename?: "PhoneNumber";
	countryCode: Scalars["String"];
	number: Scalars["String"];
}

/** Represents a user's investment portfolio, including assets, groups, and earnings. */
export interface Portfolio {
	__typename?: "Portfolio";
	assetGroups?: Maybe<PortfolioAssetGroupsConnection>;
	assets?: Maybe<PortfolioAssetsConnection>;
	earnings?: Maybe<PortfolioEarnings>;
	historicalData?: Maybe<Array<Maybe<HistoricalValue>>>;
	marginPosition?: Maybe<MarginPosition>;
	marginPositions?: Maybe<PortfolioMarginPositionsConnection>;
	overallAmount?: Maybe<Scalars["PrecisionFloat"]>;
	returnPercentage?: Maybe<Scalars["BigDecimal"]>;
}

/** Represents a user's investment portfolio, including assets, groups, and earnings. */
export interface PortfolioAssetGroupsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents a user's investment portfolio, including assets, groups, and earnings. */
export interface PortfolioAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents a user's investment portfolio, including assets, groups, and earnings. */
export interface PortfolioHistoricalDataArgs {
	period?: InputMaybe<PortfolioPeriod>;
}

/** Represents a user's investment portfolio, including assets, groups, and earnings. */
export interface PortfolioMarginPositionArgs {
	input: MarginAssetInput;
}

/** Represents a user's investment portfolio, including assets, groups, and earnings. */
export interface PortfolioMarginPositionsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	input?: InputMaybe<MarginPositionsInput>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents a user's investment portfolio, including assets, groups, and earnings. */
export interface PortfolioOverallAmountArgs {
	period?: InputMaybe<PortfolioPeriod>;
}

/** Represents a user's investment portfolio, including assets, groups, and earnings. */
export interface PortfolioReturnPercentageArgs {
	period?: InputMaybe<PortfolioPeriod>;
}

/** An edge in the asset group connection, containing an asset group node and related data. */
export interface PortfolioAssetGroupEdge {
	__typename?: "PortfolioAssetGroupEdge";
	allAssets?: Maybe<PortfolioAssetsConnection>;
	allocationPercentage?: Maybe<Scalars["BigDecimal"]>;
	assets?: Maybe<PortfolioAssetsConnection>;
	cursor?: Maybe<Scalars["String"]>;
	fiatBalance?: Maybe<Scalars["PrecisionFloat"]>;
	node?: Maybe<AssetGroup>;
	totalReturn?: Maybe<Scalars["ValueChange"]>;
}

/** An edge in the asset group connection, containing an asset group node and related data. */
export interface PortfolioAssetGroupEdgeAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** A paginated connection of asset groups in the portfolio. */
export interface PortfolioAssetGroupsConnection {
	__typename?: "PortfolioAssetGroupsConnection";
	edges?: Maybe<Array<Maybe<PortfolioAssetGroupEdge>>>;
	pageInfo?: Maybe<PageInfo>;
}

/** A paginated connection of assets in the portfolio. */
export interface PortfolioAssetsConnection {
	__typename?: "PortfolioAssetsConnection";
	edges?: Maybe<Array<Maybe<PortfolioAssetsEdge>>>;
	pageInfo?: Maybe<PageInfo>;
}

/** An edge in the assets connection, containing a broker asset node and related data. */
export interface PortfolioAssetsEdge {
	__typename?: "PortfolioAssetsEdge";
	assetBalance?: Maybe<Scalars["PrecisionFloat"]>;
	cursor?: Maybe<Scalars["String"]>;
	fiatBalance?: Maybe<Scalars["PrecisionFloat"]>;
	node?: Maybe<BrokerAsset>;
	stakedBalance?: Maybe<Scalars["ValueChange"]>;
	totalInvested?: Maybe<Scalars["PrecisionFloat"]>;
	totalReturn?: Maybe<Scalars["ValueChange"]>;
}

/** Earnings summary for the portfolio, including staking, Cash Plus, and savings plans. */
export interface PortfolioEarnings {
	__typename?: "PortfolioEarnings";
	cashPlusRewards?: Maybe<CashPlusRewards>;
	savingsPlanRewards?: Maybe<SavingsPlanRewards>;
	stakingRewards?: Maybe<StakingRewards>;
	totalRewards: Scalars["UnitValue"];
}

/** A paginated connection of margin positions in a portfolio. */
export interface PortfolioMarginPositionsConnection {
	__typename?: "PortfolioMarginPositionsConnection";
	edges?: Maybe<Array<MarginPositionEdge>>;
	pageInfo?: Maybe<PageInfo>;
}

/** Time period options for portfolio calculations. */
export enum PortfolioPeriod {
	Day = "DAY",
	Max = "MAX",
	Month = "MONTH",
	SixMonth = "SIX_MONTH",
	Week = "WEEK",
	Year = "YEAR"
}

/** Pre-launch information for a spotlight asset. */
export interface PreLaunchInfo {
	__typename?: "PreLaunchInfo";
	logos?: Maybe<Array<Image>>;
	name: Scalars["String"];
	symbol: Scalars["String"];
}

export interface PriceAlert extends Node {
	__typename?: "PriceAlert";
	amount: Scalars["UnitValue"];
	asset: Asset;
	comparison: PriceAlertComparison;
	createdAt: Scalars["DateTime"];
	fiat: Fiat;
	id: Scalars["ID"];
}

export enum PriceAlertComparison {
	Greater = "GREATER",
	Less = "LESS"
}

export interface PriceAlertEdge {
	__typename?: "PriceAlertEdge";
	cursor: Scalars["String"];
	node?: Maybe<PriceAlert>;
}

export interface PriceAlertsConnection {
	__typename?: "PriceAlertsConnection";
	edges?: Maybe<Array<Maybe<PriceAlertEdge>>>;
	pageInfo?: Maybe<PageInfo>;
	totalCount?: Maybe<Scalars["Int"]>;
}

export interface PriceAlertsInput {
	assetId?: InputMaybe<Scalars["ID"]>;
	id?: InputMaybe<Scalars["ID"]>;
}

export interface PriceStats {
	__typename?: "PriceStats";
	dailyHigh?: Maybe<Scalars["UnitValue"]>;
	dailyLow?: Maybe<Scalars["UnitValue"]>;
	dayClose?: Maybe<Scalars["UnitValue"]>;
	dayOpen?: Maybe<Scalars["UnitValue"]>;
	high52w?: Maybe<Scalars["UnitValue"]>;
	lastTradePrice?: Maybe<Scalars["UnitValue"]>;
	lastUpdated: Scalars["DateTime"];
	low52w?: Maybe<Scalars["UnitValue"]>;
}

export interface Prompt extends Node {
	__typename?: "Prompt";
	createdAt?: Maybe<Scalars["DateTime"]>;
	id: Scalars["ID"];
	name: Scalars["String"];
	primaryButton?: Maybe<PromptButton>;
	secondaryButton?: Maybe<PromptButton>;
	shortTitle: Scalars["String"];
	subtitle: Scalars["String"];
	title: Scalars["String"];
}

export interface PromptButton {
	__typename?: "PromptButton";
	action: PromptButtonAction;
	label: Scalars["String"];
}

export interface PromptButtonAction {
	type: PromptButtonActionType;
}

export enum PromptButtonActionType {
	Custom = "CUSTOM",
	Dismiss = "DISMISS",
	Navigate = "NAVIGATE"
}

export interface PromptConnection {
	__typename?: "PromptConnection";
	edges?: Maybe<Array<PromptEdge>>;
	pageInfo?: Maybe<PageInfo>;
	totalCount?: Maybe<Scalars["Int"]>;
}

export interface PromptCustomAction extends PromptButtonAction {
	__typename?: "PromptCustomAction";
	type: PromptButtonActionType;
}

export interface PromptDismissAction extends PromptButtonAction {
	__typename?: "PromptDismissAction";
	/**  always DISMISS */
	key: Scalars["String"];
	/**  e.g. "prompt:kyc-reminder:snooze" */
	ttl?: Maybe<Scalars["String"]>;
	type: PromptButtonActionType;
}

export interface PromptEdge {
	__typename?: "PromptEdge";
	cursor: Scalars["String"];
	node?: Maybe<Prompt>;
}

export interface PromptNavigateAction extends PromptButtonAction {
	__typename?: "PromptNavigateAction";
	/**  always NAVIGATE */
	path: Scalars["String"];
	type: PromptButtonActionType;
}

export interface Query {
	__typename?: "Query";
	_service: _Service;
	asset?: Maybe<Asset>;
	assets?: Maybe<AssetConnection>;
	contact?: Maybe<Contact>;
	contacts?: Maybe<ContactsConnection>;
	exchanges?: Maybe<ExchangeConnection>;
	fiat?: Maybe<Fiat>;
	fiats?: Maybe<FiatConnection>;
	marginLimitOrder?: Maybe<MarginLimitOrder>;
	marketIndicators?: Maybe<MarketIndicators>;
	portfolio?: Maybe<Portfolio>;
	priceAlerts?: Maybe<PriceAlertsConnection>;
	prompts?: Maybe<PromptConnection>;
	savingsPlans?: Maybe<SavingsPlansConnection>;
	spotlight?: Maybe<Spotlight>;
	transaction?: Maybe<Transaction>;
	transactions?: Maybe<TransactionsConnection>;
	user?: Maybe<User>;
	wallet?: Maybe<Wallet>;
	wallets?: Maybe<WalletsConnection>;
	watchlist?: Maybe<WatchlistConnection>;
}

export interface QueryAssetArgs {
	input: AssetInput;
}

export interface QueryAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	input?: InputMaybe<AssetsListInput>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface QueryContactArgs {
	input?: InputMaybe<ContactInput>;
}

export interface QueryContactsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface QueryFiatArgs {
	input?: InputMaybe<FiatInput>;
}

export interface QueryFiatsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface QueryMarginLimitOrderArgs {
	input: MarginLimitOrderInput;
}

export interface QueryMarketIndicatorsArgs {
	assetType?: InputMaybe<AssetType>;
	period?: InputMaybe<TimePeriod>;
}

export interface QueryPriceAlertsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	input?: InputMaybe<PriceAlertsInput>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface QueryPromptsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface QuerySavingsPlansArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	input?: InputMaybe<SavingsPlansInput>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface QueryTransactionArgs {
	input?: InputMaybe<TransactionInput>;
}

export interface QueryTransactionsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	input?: InputMaybe<TransactionsListInput>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface QueryWalletArgs {
	input?: InputMaybe<WalletInput>;
}

export interface QueryWalletsArgs {
	input?: InputMaybe<WalletsListInput>;
}

export interface QueryWatchlistArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	input?: InputMaybe<WatchlistInput>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface RefundTransaction extends Node, Transaction {
	__typename?: "RefundTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface RelatedAssetsConnection {
	__typename?: "RelatedAssetsConnection";
	edges?: Maybe<Array<Maybe<AssetEdge>>>;
	pageInfo?: Maybe<PageInfo>;
}

/** Input for removing assets from the watchlist. */
export interface RemoveFromWatchlistInput {
	ids?: InputMaybe<Array<Scalars["ID"]>>;
	pids?: InputMaybe<Array<Scalars["String"]>>;
}

/** Payload after removing assets to the watchlist. */
export interface RemoveFromWatchlistPayload {
	__typename?: "RemoveFromWatchlistPayload";
	removedEdges?: Maybe<Array<Maybe<WatchlistEdge>>>;
}

export interface RemovePriceAlertInput {
	id: Scalars["ID"];
}

export interface RemovePriceAlertPayload {
	__typename?: "RemovePriceAlertPayload";
	success: Scalars["Boolean"];
}

/** Input for reordering a singular watchlist item. */
export interface ReorderWatchlistInput {
	id?: InputMaybe<Scalars["ID"]>;
	order?: InputMaybe<Scalars["Int"]>;
	pid?: InputMaybe<Scalars["String"]>;
}

/** Payload after reordering assets to the watchlist. */
export interface ReorderWatchlistPayload {
	__typename?: "ReorderWatchlistPayload";
	updatedEdges?: Maybe<Array<Maybe<WatchlistEdge>>>;
}

export interface Report {
	__typename?: "Report";
	displayName: Scalars["String"];
	downloadLink: Scalars["String"];
	downloadLinkExpiryDate: Scalars["DateTime"];
	id: Scalars["ID"];
	trigger: Trigger;
	type: ReportType;
}

export enum ReportType {
	AccountStatement = "ACCOUNT_STATEMENT",
	CorporateActionsCashDividend = "CORPORATE_ACTIONS_CASH_DIVIDEND",
	CorporateActionsDelisting = "CORPORATE_ACTIONS_DELISTING",
	CorporateActionsMergerCash = "CORPORATE_ACTIONS_MERGER_CASH",
	CorporateActionsMergerCashStock = "CORPORATE_ACTIONS_MERGER_CASH_STOCK",
	CorporateActionsMergerStock = "CORPORATE_ACTIONS_MERGER_STOCK",
	CorporateActionsSpinOff = "CORPORATE_ACTIONS_SPIN_OFF",
	CorporateActionsStockDividend = "CORPORATE_ACTIONS_STOCK_DIVIDEND",
	CorporateActionsStockSplit = "CORPORATE_ACTIONS_STOCK_SPLIT",
	CryptoTax = "CRYPTO_TAX",
	SecuritiesAccountClosed = "SECURITIES_ACCOUNT_CLOSED",
	SecuritiesAccountOpened = "SECURITIES_ACCOUNT_OPENED",
	SecuritiesOrderCancelled = "SECURITIES_ORDER_CANCELLED",
	SecuritiesOrderPlaced = "SECURITIES_ORDER_PLACED",
	SecuritiesOrderRevoked = "SECURITIES_ORDER_REVOKED",
	Xpct = "XPCT"
}

export interface ResolvePromptInput {
	id: Scalars["ID"];
}

export interface ResolvePromptPayload {
	__typename?: "ResolvePromptPayload";
	success: Scalars["Boolean"];
}

export interface ReturnOfCapitalTransaction extends Node, Transaction {
	__typename?: "ReturnOfCapitalTransaction";
	amount: Scalars["UnitValue"];
	asset?: Maybe<Asset>;
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface ReverseStockSplitTransaction extends Node, Transaction {
	__typename?: "ReverseStockSplitTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	ratio?: Maybe<Scalars["String"]>;
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

export interface RewardTransaction extends Node, Transaction {
	__typename?: "RewardTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface SavingsPlan extends Node {
	__typename?: "SavingsPlan";
	amount: Scalars["UnitValue"];
	asset: Asset;
	canceledAt?: Maybe<Scalars["DateTime"]>;
	createdAt: Scalars["DateTime"];
	fiat: Fiat;
	frequency: SavingsPlanFrequency;
	id: Scalars["ID"];
	nextBuy?: Maybe<Scalars["DateTime"]>;
	state: SavingsPlanState;
}

export interface SavingsPlanEdge {
	__typename?: "SavingsPlanEdge";
	cursor: Scalars["String"];
	node?: Maybe<SavingsPlan>;
}

export enum SavingsPlanFrequency {
	Biweekly = "BIWEEKLY",
	Daily = "DAILY",
	Monthly = "MONTHLY",
	Weekly = "WEEKLY"
}

/** Savings plan rewards summary for the portfolio. */
export interface SavingsPlanRewards {
	__typename?: "SavingsPlanRewards";
	activePlanCount: Scalars["Int"];
}

export enum SavingsPlanState {
	Active = "ACTIVE",
	Canceled = "CANCELED",
	Paused = "PAUSED",
	Pending = "PENDING"
}

export interface SavingsPlanTransaction extends Node, Transaction {
	__typename?: "SavingsPlanTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	/**  Additional fields */
	cardNumber?: Maybe<Scalars["String"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	iban?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	nextScheduledBuy?: Maybe<Scalars["DateTime"]>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	price?: Maybe<Scalars["PriceUnitValue"]>;
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
	vsnPrice?: Maybe<Scalars["PriceUnitValue"]>;
	vsnUsed?: Maybe<Scalars["UnitValue"]>;
}

export interface SavingsPlansConnection {
	__typename?: "SavingsPlansConnection";
	edges?: Maybe<Array<SavingsPlanEdge>>;
	pageInfo?: Maybe<PageInfo>;
	totalCount?: Maybe<Scalars["Int"]>;
}

export interface SavingsPlansInput {
	assetId?: InputMaybe<Scalars["ID"]>;
	id?: InputMaybe<Scalars["ID"]>;
	state?: InputMaybe<SavingsPlanState>;
}

export interface ScheduleOverride {
	__typename?: "ScheduleOverride";
	/**  ISO date format */
	date: Scalars["Date"];
	windows: Array<ScheduleWindow>;
}

export interface ScheduleWindow {
	__typename?: "ScheduleWindow";
	/**  Time in HH:mm format (e.g., "07:30", "22:00") */
	close: Scalars["String"];
	/**  Time in HH:mm format (e.g., "07:30", "22:00") */
	open: Scalars["String"];
}

/** Represents a security token asset. */
export interface SecurityTokenAsset extends Asset, Node {
	__typename?: "SecurityTokenAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	/**  Additional fields */
	documents?: Maybe<Array<AssetDocument>>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceHighDay?: Maybe<Scalars["UnitValue"]>;
	priceHighYear?: Maybe<Scalars["UnitValue"]>;
	priceLowDay?: Maybe<Scalars["UnitValue"]>;
	priceLowYear?: Maybe<Scalars["UnitValue"]>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volatilityPercentage30d?: Maybe<Scalars["PrecisionFloat"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Represents a security token asset. */
export interface SecurityTokenAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a security token asset. */
export interface SecurityTokenAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a security token asset. */
export interface SecurityTokenAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

export interface SellTransaction extends Node, Transaction {
	__typename?: "SellTransaction";
	actions?: Maybe<Array<TransactionAction>>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	capitalGain?: Maybe<Scalars["UnitValue"]>;
	closingPosition?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	price?: Maybe<Scalars["PriceUnitValue"]>;
	receivedAmount?: Maybe<Scalars["UnitValue"]>;
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	startingPosition?: Maybe<Scalars["UnitValue"]>;
	status: TransactionStatus;
	taxWithheld?: Maybe<Scalars["UnitValue"]>;
	taxableAmount?: Maybe<Scalars["UnitValue"]>;
	to?: Maybe<Wallet>;
	type: TransactionType;
	vsnPrice?: Maybe<Scalars["PriceUnitValue"]>;
	vsnUsed?: Maybe<Scalars["UnitValue"]>;
}

/** The sort order. */
export enum SortOrder {
	Asc = "ASC",
	Desc = "DESC"
}

export interface SpinOffReceivedTransaction extends Node, Transaction {
	__typename?: "SpinOffReceivedTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface SpinOffSentTransaction extends Node, Transaction {
	__typename?: "SpinOffSentTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
}

/** Root type for Spotlight feature, providing asset and newsletter information. */
export interface Spotlight {
	__typename?: "Spotlight";
	asset?: Maybe<SpotlightAsset>;
	assets?: Maybe<SpotlightAssetConnection>;
	isSubscribedToNewsletter?: Maybe<Scalars["Boolean"]>;
}

/** Root type for Spotlight feature, providing asset and newsletter information. */
export interface SpotlightAssetArgs {
	input: SpotlightAssetInput;
}

/** Root type for Spotlight feature, providing asset and newsletter information. */
export interface SpotlightAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** Represents a single spotlight asset with details and status. */
export interface SpotlightAsset {
	__typename?: "SpotlightAsset";
	asset?: Maybe<Asset>;
	description?: Maybe<Scalars["String"]>;
	giveAwayTokens?: Maybe<Scalars["PrecisionFloat"]>;
	isLive: Scalars["Boolean"];
	isSubscribed?: Maybe<Scalars["Boolean"]>;
	launchDate: Scalars["DateTime"];
	paperUrl?: Maybe<Scalars["String"]>;
	participants?: Maybe<Scalars["Int"]>;
	preLaunchInfo?: Maybe<PreLaunchInfo>;
	socials?: Maybe<Array<SpotlightSocial>>;
	spotlightId: Scalars["Int"];
	totalTokensOffered?: Maybe<Scalars["PrecisionFloat"]>;
}

/** A paginated connection of spotlight assets. */
export interface SpotlightAssetConnection {
	__typename?: "SpotlightAssetConnection";
	edges?: Maybe<Array<SpotlightAssetEdge>>;
	pageInfo?: Maybe<PageInfo>;
}

/** An edge in the spotlight asset connection, containing a node and a cursor. */
export interface SpotlightAssetEdge {
	__typename?: "SpotlightAssetEdge";
	cursor?: Maybe<Scalars["String"]>;
	node?: Maybe<SpotlightAsset>;
}

/** Input for fetching a specific spotlight asset. */
export interface SpotlightAssetInput {
	spotlightId: Scalars["Int"];
}

/** Input for subscribing or unsubscribing to a spotlight asset. */
export interface SpotlightAssetSubscriptionInput {
	isSubscribed: Scalars["Boolean"];
	spotlightAssetId: Scalars["Int"];
}

/** Input for subscribing or unsubscribing to the spotlight newsletter. */
export interface SpotlightNewsletterSubscriptionInput {
	isSubscribed?: InputMaybe<Scalars["Boolean"]>;
}

/** Represents a social link for a spotlight asset. */
export interface SpotlightSocial {
	__typename?: "SpotlightSocial";
	name: Scalars["String"];
	url: Scalars["String"];
}

export interface StakeTransaction extends Node, Transaction {
	__typename?: "StakeTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
}

/** Staking information for an asset. */
export interface Staking {
	__typename?: "Staking";
	estimatedRewards: Scalars["PrecisionFloat"];
}

export interface StakingRewardTransaction extends Node, Transaction {
	__typename?: "StakingRewardTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Staking rewards summary for the portfolio. */
export interface StakingRewards {
	__typename?: "StakingRewards";
	highestPotentialStakingYield: Scalars["PrecisionFloat"];
	stakedAssetCount: Scalars["Int"];
	totalRewards: Scalars["UnitValue"];
}

/** Represents a stock asset. */
export interface StockAsset extends Asset, Node {
	__typename?: "StockAsset";
	automatedOrderActive?: Maybe<Scalars["Boolean"]>;
	available?: Maybe<Scalars["Boolean"]>;
	buyActive?: Maybe<Scalars["Boolean"]>;
	circulatingSupply?: Maybe<Scalars["BigDecimal"]>;
	depositActive?: Maybe<Scalars["Boolean"]>;
	description?: Maybe<Scalars["String"]>;
	/**  Additional fields */
	documents?: Maybe<Array<AssetDocument>>;
	fundSize?: Maybe<Scalars["UnitValue"]>;
	fundSizeYear?: Maybe<Scalars["Int"]>;
	id: Scalars["ID"];
	/** @deprecated Should only be used for backward compatibility with the old webapp. Use id instead. */
	idInternal: Scalars["Int"];
	inWatchlist: Scalars["Boolean"];
	lastTradingDay?: Maybe<AssetLastTradingDay>;
	lastUpdated?: Maybe<Scalars["DateTime"]>;
	logos: Array<Image>;
	maintenanceEnabled?: Maybe<Scalars["Boolean"]>;
	marketCap?: Maybe<Scalars["PrecisionFloat"]>;
	metrics?: Maybe<StockAssetMetrics>;
	minWithdrawal?: Maybe<Scalars["PrecisionFloat"]>;
	minimumBuyAmount?: Maybe<Scalars["PrecisionFloat"]>;
	minimumSellAmount?: Maybe<Scalars["PrecisionFloat"]>;
	name: Scalars["String"];
	ohlc?: Maybe<Array<OhlcData>>;
	orderTypes?: Maybe<Array<Maybe<AssetOrderType>>>;
	pid: Scalars["String"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForCoins: Scalars["Int"];
	/** @deprecated Should only be used for backward compatibility. The precision should be provided along with the amount via UnitValue scalar. */
	precisionForFiatPrice: Scalars["Int"];
	price: Scalars["PrecisionFloat"];
	priceChange: Scalars["ValueChange"];
	priceHighDay?: Maybe<Scalars["UnitValue"]>;
	priceHighYear?: Maybe<Scalars["UnitValue"]>;
	priceLowDay?: Maybe<Scalars["UnitValue"]>;
	priceLowYear?: Maybe<Scalars["UnitValue"]>;
	relatedAssets?: Maybe<RelatedAssetsConnection>;
	sellActive?: Maybe<Scalars["Boolean"]>;
	symbol: Scalars["String"];
	tags?: Maybe<Array<AssetTagType>>;
	transferActive?: Maybe<Scalars["Boolean"]>;
	volatilityPercentage30d?: Maybe<Scalars["PrecisionFloat"]>;
	volume30d?: Maybe<Scalars["BigDecimal"]>;
	walletMinDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDeposit?: Maybe<Scalars["PrecisionFloat"]>;
	walletSmallDepositFee?: Maybe<Scalars["PrecisionFloat"]>;
	wallets?: Maybe<AssetWalletsConnection>;
	withdrawActive?: Maybe<Scalars["Boolean"]>;
}

/** Represents a stock asset. */
export interface StockAssetOhlcArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a stock asset. */
export interface StockAssetPriceChangeArgs {
	period?: InputMaybe<TimePeriod>;
}

/** Represents a stock asset. */
export interface StockAssetRelatedAssetsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** The type which indicates analyst ratings for a stock asset. */
export interface StockAssetAnalystRatings {
	__typename?: "StockAssetAnalystRatings";
	/**  returned as null until clarified */
	averageTargetPrice?: Maybe<Scalars["UnitValue"]>;
	averageTargetPriceChangePercentage?: Maybe<Scalars["PrecisionFloat"]>;
	buyPercentage?: Maybe<Scalars["PrecisionFloat"]>;
	holdPercentage?: Maybe<Scalars["PrecisionFloat"]>;
	ratings?: Maybe<Scalars["Int"]>;
	sellPercentage?: Maybe<Scalars["PrecisionFloat"]>;
}

/** Represents metrics for a stock. */
export interface StockAssetMetrics {
	__typename?: "StockAssetMetrics";
	analystRatings?: Maybe<StockAssetAnalystRatings>;
	dividendPerShareYear?: Maybe<Scalars["Int"]>;
	dividendPerShareYearly?: Maybe<Scalars["UnitValue"]>;
	dividendYieldYear?: Maybe<Scalars["Int"]>;
	dividendYieldYearly?: Maybe<Scalars["PrecisionFloat"]>;
	earningsPerShareYear?: Maybe<Scalars["Int"]>;
	earningsPerShareYearly?: Maybe<Scalars["UnitValue"]>;
	isin: Scalars["String"];
	peRatioYear?: Maybe<Scalars["Int"]>;
	peRatioYearly?: Maybe<Scalars["PrecisionFloat"]>;
	revenueYear?: Maybe<Scalars["Int"]>;
	revenueYearly?: Maybe<Scalars["UnitValue"]>;
	yearlyNetIncomes?: Maybe<Array<Maybe<StockAssetNetIncome>>>;
}

/** The type which indicates net income for a given year. */
export interface StockAssetNetIncome {
	__typename?: "StockAssetNetIncome";
	netIncome?: Maybe<Scalars["UnitValue"]>;
	year?: Maybe<Scalars["Int"]>;
}

export interface StockExchange extends Exchange, Node {
	__typename?: "StockExchange";
	id: Scalars["ID"];
	marketHours: MarketHours;
	/**  timezone format e.g. "Europe/Vienna" */
	timezone: Scalars["String"];
}

export interface StockMergerTransaction extends Node, Transaction {
	__typename?: "StockMergerTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	capitalGain?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	incomingAssetAmount?: Maybe<Scalars["UnitValue"]>;
	operationType?: Maybe<OperationType>;
	/**  Additional fields */
	outgoingAssetAmount?: Maybe<Scalars["UnitValue"]>;
	pid: Scalars["String"];
	ratio?: Maybe<Scalars["String"]>;
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	taxWithheld?: Maybe<Scalars["UnitValue"]>;
	taxableAmount?: Maybe<Scalars["UnitValue"]>;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface StockSplitTransaction extends Node, Transaction {
	__typename?: "StockSplitTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	ratio?: Maybe<Scalars["String"]>;
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** Subscriptions for the asset price. */
export interface Subscription {
	__typename?: "Subscription";
	assetPriceUpdate: Asset;
	assetPriceUpdates: Array<Asset>;
}

/** Subscriptions for the asset price. */
export interface SubscriptionAssetPriceUpdateArgs {
	input: AssetPriceUpdateInput;
	sampleIntervalSeconds?: InputMaybe<Scalars["Int"]>;
}

/** Subscriptions for the asset price. */
export interface SubscriptionAssetPriceUpdatesArgs {
	input: AssetPriceUpdateInput;
	sampleIntervalSeconds?: InputMaybe<Scalars["Int"]>;
}

export interface SwapTransaction extends Node, Transaction {
	__typename?: "SwapTransaction";
	/**  Additional fields */
	actions?: Maybe<Array<TransactionAction>>;
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	buyAmount?: Maybe<Scalars["UnitValue"]>;
	buyPrice?: Maybe<Scalars["PriceUnitValue"]>;
	capitalGain?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	receivedAmount?: Maybe<Scalars["UnitValue"]>;
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	sellAmount?: Maybe<Scalars["UnitValue"]>;
	sellPrice?: Maybe<Scalars["PriceUnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	taxWithheld?: Maybe<Scalars["UnitValue"]>;
	taxableAmount?: Maybe<Scalars["UnitValue"]>;
	to?: Maybe<Wallet>;
	type: TransactionType;
	vsnPrice?: Maybe<Scalars["PriceUnitValue"]>;
	vsnUsed?: Maybe<Scalars["UnitValue"]>;
}

export interface TaxRefundTransaction extends Node, Transaction {
	__typename?: "TaxRefundTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** The available time periods for OHLC data */
export enum TimePeriod {
	Day = "DAY",
	FiveYears = "FIVE_YEARS",
	Month = "MONTH",
	SixMonths = "SIX_MONTHS",
	Week = "WEEK",
	Year = "YEAR"
}

export interface TradingPremiumTransaction extends Node, Transaction {
	__typename?: "TradingPremiumTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	effectiveDiscount?: Maybe<Scalars["UnitValue"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	price?: Maybe<Scalars["PriceUnitValue"]>;
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/**
 * Transactions are generally loaded from
 *
 * /api/v2/restricted/virtual/accounts/operations both for listing and the details view.
 *
 * List will also load pending transactions from payments engine /v1/payments/transactions/in-progress
 */
export interface Transaction {
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

/**  Enum representing the action this transaction can have  */
export enum TransactionAction {
	BeneficiaryDetails = "BENEFICIARY_DETAILS",
	BuyMore = "BUY_MORE",
	Cancel = "CANCEL",
	ConfirmBySca = "CONFIRM_BY_SCA",
	ConfirmEmail = "CONFIRM_EMAIL",
	ConfirmSms = "CONFIRM_SMS",
	ContactSupport = "CONTACT_SUPPORT",
	IncreaseMarginPosition = "INCREASE_MARGIN_POSITION",
	MakePayment = "MAKE_PAYMENT",
	SellMore = "SELL_MORE",
	SwapMore = "SWAP_MORE"
}

export interface TransactionCorrectionTransaction extends Node, Transaction {
	__typename?: "TransactionCorrectionTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface TransactionEdge {
	__typename?: "TransactionEdge";
	cursor: Scalars["String"];
	node?: Maybe<Transaction>;
}

/** # Facets */
export interface TransactionFacet extends Facet {
	__typename?: "TransactionFacet";
	field?: Maybe<Scalars["String"]>;
	values?: Maybe<Array<Maybe<FacetValue>>>;
}

/** Facet option for filtering transactions. */
export interface TransactionFacetOption extends FacetOption {
	__typename?: "TransactionFacetOption";
	key: FacetOptionKey;
	values: Array<FacetOptionValue>;
}

/**  Enum representing the flow direction of a transaction  */
export enum TransactionFlow {
	Incoming = "INCOMING",
	Outgoing = "OUTGOING"
}

export interface TransactionInput {
	id?: InputMaybe<Scalars["ID"]>;
	pid?: InputMaybe<Scalars["String"]>;
}

export interface TransactionReversal {
	__typename?: "TransactionReversal";
	reason: Scalars["String"];
}

/**  Enum representing the status of an operation/transaction  */
export enum TransactionStatus {
	Approved = "APPROVED",
	Cancelled = "CANCELLED",
	Finished = "FINISHED",
	Initiated = "INITIATED",
	InReview = "IN_REVIEW",
	OnHold = "ON_HOLD",
	Pending = "PENDING",
	Processing = "PROCESSING",
	Refunded = "REFUNDED",
	Rejected = "REJECTED",
	WaitingForPayment = "WAITING_FOR_PAYMENT"
}

/**
 * Enum representing the transaction type returned by BFF
 * these are mapped to the operation type returned by transaction timeline
 */
export enum TransactionType {
	AffiliatePayout = "AFFILIATE_PAYOUT",
	Airdrop = "AIRDROP",
	AssetDeposit = "ASSET_DEPOSIT",
	AssetWithdrawal = "ASSET_WITHDRAWAL",
	BestReward = "BEST_REWARD",
	BitpandaPayDebit = "BITPANDA_PAY_DEBIT",
	Buy = "BUY",
	CardCashback = "CARD_CASHBACK",
	CardCredit = "CARD_CREDIT",
	CardFee = "CARD_FEE",
	CardPayment = "CARD_PAYMENT",
	CashPlusAdded = "CASH_PLUS_ADDED",
	CashPlusRemoved = "CASH_PLUS_REMOVED",
	CashPlusReward = "CASH_PLUS_REWARD",
	Chargeback = "CHARGEBACK",
	CryptoMerger = "CRYPTO_MERGER",
	Delisting = "DELISTING",
	Dividend = "DIVIDEND",
	FiatDeposit = "FIAT_DEPOSIT",
	FiatWithdrawal = "FIAT_WITHDRAWAL",
	FundsReleased = "FUNDS_RELEASED",
	FundsReserved = "FUNDS_RESERVED",
	Generic = "GENERIC",
	Giveaway = "GIVEAWAY",
	Ico = "ICO",
	IncomingTransfer = "INCOMING_TRANSFER",
	IndexBuy = "INDEX_BUY",
	IndexClaim = "INDEX_CLAIM",
	IndexRebalance = "INDEX_REBALANCE",
	IndexSell = "INDEX_SELL",
	InstantTradeBonus = "INSTANT_TRADE_BONUS",
	LeverageLiquidation = "LEVERAGE_LIQUIDATION",
	Liquidation = "LIQUIDATION",
	MarginBorrowFunds = "MARGIN_BORROW_FUNDS",
	MarginClosePosition = "MARGIN_CLOSE_POSITION",
	MarginFee = "MARGIN_FEE",
	MarginIncreasePosition = "MARGIN_INCREASE_POSITION",
	MarginLiquidation = "MARGIN_LIQUIDATION",
	MarginOpenPosition = "MARGIN_OPEN_POSITION",
	MarginRepayFunds = "MARGIN_REPAY_FUNDS",
	MetalStorageFee = "METAL_STORAGE_FEE",
	OutgoingTransfer = "OUTGOING_TRANSFER",
	Refund = "REFUND",
	ReverseStockSplit = "REVERSE_STOCK_SPLIT",
	Reward = "REWARD",
	SavingsPlan = "SAVINGS_PLAN",
	SecuritiesDeposit = "SECURITIES_DEPOSIT",
	SecuritiesWithdrawal = "SECURITIES_WITHDRAWAL",
	Sell = "SELL",
	SpinOffReceived = "SPIN_OFF_RECEIVED",
	SpinOffSent = "SPIN_OFF_SENT",
	Stake = "STAKE",
	StakingReward = "STAKING_REWARD",
	StockMerger = "STOCK_MERGER",
	StockSplit = "STOCK_SPLIT",
	Swap = "SWAP",
	TaxRefund = "TAX_REFUND",
	TradingPremium = "TRADING_PREMIUM",
	TransactionCorrection = "TRANSACTION_CORRECTION",
	Unstake = "UNSTAKE",
	VisionFee = "VISION_FEE",
	Voucher = "VOUCHER",
	WorthlessRemoval = "WORTHLESS_REMOVAL"
}

/** Value for a transaction type facet option. */
export interface TransactionTypeFacetOptionValue extends FacetOptionValue {
	__typename?: "TransactionTypeFacetOptionValue";
	count?: Maybe<Scalars["Int"]>;
	typeFilter?: Maybe<TransactionTypeFilter>;
	value: Scalars["String"];
}

export interface TransactionTypeFacetValue extends FacetValue {
	__typename?: "TransactionTypeFacetValue";
	count?: Maybe<Scalars["Int"]>;
	key?: Maybe<Scalars["String"]>;
	value?: Maybe<TransactionTypeFilter>;
}

/**  Enum representing the possible filters for transactions  */
export enum TransactionTypeFilter {
	All = "ALL",
	BitpandaCard = "BITPANDA_CARD",
	Buy = "BUY",
	Deposit = "DEPOSIT",
	Fee = "FEE",
	MarginTrading = "MARGIN_TRADING",
	Others = "OTHERS",
	Rewards = "REWARDS",
	SavingsPlan = "SAVINGS_PLAN",
	Sell = "SELL",
	Staking = "STAKING",
	Swap = "SWAP",
	Tax = "TAX",
	WithdrawAndSend = "WITHDRAW_AND_SEND"
}

export interface TransactionsConnection {
	__typename?: "TransactionsConnection";
	edges?: Maybe<Array<Maybe<TransactionEdge>>>;
	facetOptions?: Maybe<Array<FacetOption>>;
	facets?: Maybe<Array<Facet>>;
	pageInfo?: Maybe<PageInfo>;
}

export interface TransactionsListInput {
	assets?: InputMaybe<Array<Scalars["ID"]>>;
	endDate?: InputMaybe<Scalars["DateTime"]>;
	facets?: InputMaybe<Array<FacetOptionInput>>;
	query?: InputMaybe<Scalars["String"]>;
	startDate?: InputMaybe<Scalars["DateTime"]>;
	type?: InputMaybe<TransactionTypeFilter>;
}

export enum Trigger {
	Event = "EVENT",
	OnDemand = "ON_DEMAND",
	Schedule = "SCHEDULE"
}

/** Theme enum for the image. */
export enum UiTheme {
	Dark = "DARK",
	Light = "LIGHT"
}

export interface UnstakeTransaction extends Node, Transaction {
	__typename?: "UnstakeTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

export interface User extends Node {
	__typename?: "User";
	address?: Maybe<Address>;
	birthday?: Maybe<Scalars["Date"]>;
	businessAddress?: Maybe<Address>;
	businessName?: Maybe<Scalars["String"]>;
	citizenshipCountry?: Maybe<Country>;
	email: Scalars["String"];
	forename: Scalars["String"];
	gender?: Maybe<Gender>;
	id: Scalars["ID"];
	isActive: Scalars["Boolean"];
	isVerified: Scalars["Boolean"];
	language?: Maybe<Scalars["String"]>;
	locale?: Maybe<Scalars["String"]>;
	phoneNumber?: Maybe<PhoneNumber>;
	pid: Scalars["String"];
	residencyCountry: Country;
	surname: Scalars["String"];
	userType?: Maybe<UserType>;
}

/** An edge in the users connection, containing a user node and a cursor. */
export interface UserEdge {
	__typename?: "UserEdge";
	cursor: Scalars["String"];
	node?: Maybe<User>;
}

/** Input for identifying a specific user. */
export interface UserInput {
	email?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
}

/** Status of a user account. */
export enum UserStatus {
	Active = "ACTIVE",
	Inactive = "INACTIVE",
	Suspended = "SUSPENDED"
}

export enum UserType {
	Business = "BUSINESS",
	Retail = "RETAIL"
}

/** A paginated connection of users. */
export interface UsersConnection {
	__typename?: "UsersConnection";
	edges?: Maybe<Array<Maybe<UserEdge>>>;
	pageInfo?: Maybe<PageInfo>;
	totalCount?: Maybe<Scalars["Int"]>;
}

/** Input for listing users, optionally filtered by status. */
export interface UsersListInput {
	status?: InputMaybe<UserStatus>;
}

export interface VisionFeeTransaction extends Node, Transaction {
	__typename?: "VisionFeeTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	/**  Additional fields */
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	legalClassification?: Maybe<LegalClassification>;
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	price?: Maybe<Scalars["PriceUnitValue"]>;
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Scalars["String"]>;
	type: TransactionType;
}

export interface VoucherTransaction extends Node, Transaction {
	__typename?: "VoucherTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	/**  Additional fields */
	relatedTransactions?: Maybe<Array<Transaction>>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	to?: Maybe<Wallet>;
	type: TransactionType;
}

/** A wallet interface representing a generic wallet. */
export interface Wallet {
	availableBalance?: Maybe<Scalars["UnitValue"]>;
	id: Scalars["ID"];
	name: Scalars["String"];
	pid: Scalars["String"];
	reservedBalance?: Maybe<Scalars["UnitValue"]>;
	totalBalance?: Maybe<Scalars["UnitValue"]>;
	transactions?: Maybe<TransactionsConnection>;
}

/** A wallet interface representing a generic wallet. */
export interface WalletTransactionsArgs {
	after?: InputMaybe<Scalars["String"]>;
	before?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	input?: InputMaybe<TransactionsListInput>;
	last?: InputMaybe<Scalars["Int"]>;
}

/** An edge in the wallets connection, containing a wallet node and a cursor. */
export interface WalletEdge {
	__typename?: "WalletEdge";
	cursor: Scalars["String"];
	node?: Maybe<Wallet>;
}

/** Input for identifying a specific wallet. */
export interface WalletInput {
	id?: InputMaybe<Scalars["ID"]>;
	pid?: InputMaybe<Scalars["String"]>;
}

/** Type of wallet, either FIAT or ASSET. */
export enum WalletType {
	Asset = "ASSET",
	Fiat = "FIAT"
}

/** A paginated connection of wallets, including balances. */
export interface WalletsConnection {
	__typename?: "WalletsConnection";
	availableBalance?: Maybe<Scalars["UnitValue"]>;
	edges?: Maybe<Array<Maybe<WalletEdge>>>;
	pageInfo?: Maybe<PageInfo>;
	reservedBalance?: Maybe<Scalars["UnitValue"]>;
	totalBalance?: Maybe<Scalars["UnitValue"]>;
}

/** Input for listing wallets, optionally filtered by type. */
export interface WalletsListInput {
	walletType?: InputMaybe<WalletType>;
}

/** A connection type for watchlist items, allowing pagination and sorting. */
export interface WatchlistConnection {
	__typename?: "WatchlistConnection";
	edges?: Maybe<Array<Maybe<WatchlistEdge>>>;
	pageInfo?: Maybe<PageInfo>;
	totalCount?: Maybe<Scalars["Int"]>;
}

/** an edge in the watchlist connection, representing a single asset with its cursor and order. */
export interface WatchlistEdge {
	__typename?: "WatchlistEdge";
	cursor?: Maybe<Scalars["String"]>;
	node?: Maybe<Asset>;
	order?: Maybe<Scalars["Int"]>;
}

/** Input to filter and sort watchlist items. */
export interface WatchlistInput {
	filters?: InputMaybe<AssetFilter>;
	/** Search query to filter watchlist items by asset name or symbol. */
	query?: InputMaybe<Scalars["String"]>;
	sortBy?: InputMaybe<AssetSort>;
	sortOrder?: InputMaybe<SortOrder>;
}

export enum WeekDay {
	Friday = "FRIDAY",
	Monday = "MONDAY",
	Saturday = "SATURDAY",
	Sunday = "SUNDAY",
	Thursday = "THURSDAY",
	Tuesday = "TUESDAY",
	Wednesday = "WEDNESDAY"
}

export interface WeeklySchedule {
	__typename?: "WeeklySchedule";
	weekday: WeekDay;
	windows: Array<ScheduleWindow>;
}

/** Removes stock positions that do not have any value. */
export interface WorthlessRemovalTransaction extends Node, Transaction {
	__typename?: "WorthlessRemovalTransaction";
	amount: Scalars["UnitValue"];
	balanceAfter?: Maybe<Scalars["UnitValue"]>;
	date: Scalars["DateTime"];
	/**  asset */
	exchange?: Maybe<Scalars["String"]>;
	fee?: Maybe<Scalars["UnitValue"]>;
	feePercentage?: Maybe<Scalars["BigDecimal"]>;
	fiatAmount?: Maybe<Scalars["UnitValue"]>;
	from?: Maybe<Wallet>;
	id: Scalars["ID"];
	operationType?: Maybe<OperationType>;
	pid: Scalars["String"];
	relatedTransactions?: Maybe<Array<Transaction>>;
	/**  additional fields */
	report?: Maybe<Report>;
	reversal?: Maybe<TransactionReversal>;
	secondaryAmount?: Maybe<Scalars["UnitValue"]>;
	spread?: Maybe<Scalars["UnitValue"]>;
	spreadPercentage?: Maybe<Scalars["BigDecimal"]>;
	status: TransactionStatus;
	type: TransactionType;
}

export interface _Service {
	__typename?: "_Service";
	sdl: Scalars["String"];
}
